<template>
<svg version="1.1" id="A-22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 144 220" enable-background="new 0 0 144 220" xml:space="preserve">
<g id="StemAndScrew_A-22">
	<linearGradient id="stemGradient_A-22" gradientUnits="userSpaceOnUse" x1="133.2609" y1="106.284" x2="128.7263" y2="114.1381">
		<stop  offset="0" style="stop-color:#F2F2F2"/>
		<stop  offset="1" style="stop-color:#C6C7C9"/>
	</linearGradient>

		<rect x="122.1" y="109.525" fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" width="17.8" height="1.35"/>
	<g>
		<linearGradient id="screwGradient_A-22" gradientUnits="userSpaceOnUse" x1="133.8141" y1="106.415" x2="129.3734" y2="114.1066">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#B2B3B5"/>
		</linearGradient>
		<polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="134.1,113.9343
			133.5527,113.7296 133.05,113.9343 132.5027,113.7296 132,113.9343 131.4527,113.7296 130.95,113.9343 130.4028,113.7296
			129.9,113.9343 129.1,113.9343 129.1,106.5657 129.6472,106.7704 130.15,106.5657 130.6972,106.7704 131.2,106.5657
			131.7472,106.7704 132.25,106.5657 132.7972,106.7704 133.3,106.5657 133.8472,106.7704 134.1,106.5657 		"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.1" y1="106.5657" x2="129.9" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.15" y1="106.5657" x2="130.95" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.2" y1="106.5657" x2="132" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.25" y1="106.5657" x2="133.05" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.6472" y1="106.7704" x2="130.4028" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.6972" y1="106.7704" x2="131.4527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7472" y1="106.7704" x2="132.5027" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.7972" y1="106.7704" x2="133.5527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.8472" y1="106.7704" x2="134.1" y2="109.0985"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.3" y1="106.5657" x2="134.1" y2="113.9343"/>
	</g>
</g>
<g id="Pushers_A-22">
	<g id="Pusher-B_A-22">

			<linearGradient id="SVGID_1_A-22" gradientUnits="userSpaceOnUse" x1="618.7128" y1="-320.398" x2="612.6681" y2="-309.9283" gradientTransform="matrix(0.866 0.5 -0.5 0.866 -564.3703 106.7351)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<polygon id="Pusher-B_Button_A-22" class="pusher-button" fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" points="120.1993,142.9588 124.4512,135.5943 132.6344,140.3188 128.3825,147.6833 		"/>

			<linearGradient id="SVGID_2_A-22" gradientUnits="userSpaceOnUse" x1="616.9075" y1="-320.4211" x2="610.8562" y2="-309.9399" gradientTransform="matrix(0.866 0.5 -0.5 0.866 -564.3704 106.7349)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" d="M119.916,143.4494l4.8186-8.3458
			c0.2349-0.4068,0.7551-0.5462,1.1619-0.3113l0,0l3.5593,2.0551c0.4068,0.2349,0.5462,0.7551,0.3113,1.162l0,0l-4.8187,8.346
			c-0.2349,0.4068-0.7551,0.5462-1.1619,0.3113l0,0l-3.5593-2.0551C119.8204,144.3765,119.6811,143.8562,119.916,143.4494z"/>
	</g>
	<g id="Pusher-A_A-22">

			<linearGradient id="SVGID_3_A-22" gradientUnits="userSpaceOnUse" x1="-684.2391" y1="944.462" x2="-684.2391" y2="952.9661" gradientTransform="matrix(0.866 -0.5 0.5 0.866 244.6108 -1084.9016)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<polygon id="Pusher-A_Button_A-22" class="pusher-button" fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" points="120.1992,77.4844 128.3823,72.7597 132.6343,80.1241 124.4513,84.8488 		"/>

			<linearGradient id="SVGID_4_A-22" gradientUnits="userSpaceOnUse" x1="-686.0615" y1="943.0464" x2="-686.0615" y2="954.385" gradientTransform="matrix(0.866 -0.5 0.5 0.866 244.6128 -1084.9045)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" d="M120.2272,75.8319l3.5593-2.0551
			c0.4068-0.2349,0.9271-0.0955,1.1619,0.3113l0,0l4.8187,8.3459c0.2349,0.4068,0.0955,0.9271-0.3113,1.1619l0,0l-3.5593,2.0551
			c-0.4069,0.2349-0.9273,0.0955-1.1622-0.3114l-4.8185-8.3455C119.6808,76.5872,119.8203,76.0668,120.2272,75.8319z"/>
	</g>
</g>
<g id="CrownAndArrows_A-22">
  <g id="Arrows_A-22">
    <g id="Arrow_clockwise_A-22">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M137.6404,94.8417
        c-0.5838,0.3434-1.2641,0.5403-1.9904,0.5403c-2.1716,0-3.932-1.7604-3.932-3.932c0-2.1716,1.7604-3.932,3.932-3.932
        c2.1716,0,3.932,1.7604,3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="140.1244,89.3858 139.582,91.45
        138.0707,89.9533 		"/>
    </g>
    <g id="Arrow_counterclockwise_A-22">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M133.6596,132.3417
        c0.5838,0.3434,1.2641,0.5403,1.9904,0.5403c2.1716,0,3.932-1.7604,3.932-3.932c0-2.1716-1.7604-3.932-3.932-3.932
        c-2.1716,0-3.932,1.7604-3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="131.1756,126.8858 131.718,128.95
        133.2293,127.4533 		"/>
    </g>
  </g>
  <g id="Crown_A-22">
    <path fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" d="M139.0635,118.5543
      c0,0,1.455-2.1061,1.455-8.32s-1.455-8.3235-1.455-8.3235"/>
    <polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="138.9015,119.5674
      139.0635,119.1694 139.0635,101.2694 138.9015,100.8744 138.2895,100.2994 131.7815,100.2994 131.1725,101.9104 131.1645,118.5544
      131.8015,120.1414 138.2995,120.1414 	"/>
    <linearGradient id="SVGID_7_A-22" gradientUnits="userSpaceOnUse" x1="140.1417" y1="481.8776" x2="129.9398" y2="499.5478" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
      <stop  offset="0" style="stop-color:#F2F2F2"/>
      <stop  offset="1" style="stop-color:#C6C7C9"/>
    </linearGradient>
    <polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="131.7905,101.9104
      131.1725,101.9104 131.7815,100.3224 138.2815,100.3224 138.8905,101.9104 138.2895,101.9104 138.9025,103.2644
      138.3025,103.7304 138.9115,105.2404 138.3025,106.0984 138.8835,107.6534 138.3025,108.8394 138.9115,110.2084
      138.3025,111.6244 138.9185,112.8094 138.2805,114.3634 138.8885,115.2224 138.2805,116.7354 138.8985,117.2004
      138.2935,118.5544 138.9095,118.5544 138.2995,120.1414 131.8015,120.1414 131.1925,118.5544 131.7935,118.5544
      131.1775,117.2004 131.7805,116.7354 131.1705,115.2224 131.7805,114.3634 131.1995,112.8094 131.7805,111.6244
      131.2025,110.2084 131.7935,108.8394 131.1645,107.6534 131.8015,106.0984 131.1925,105.2404 131.8015,103.7304
      131.1845,103.2644 		"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7907" y1="101.9105" x2="138.2894" y2="101.9105"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.8018" y1="103.7308" x2="138.3024" y2="103.7308"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.8018" y1="106.0986" x2="138.3024" y2="106.0986"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.794" y1="108.8395" x2="138.3024" y2="108.8395"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7803" y1="111.6247" x2="138.3024" y2="111.6247"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7803" y1="114.3636" x2="138.2803" y2="114.3636"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7803" y1="116.7353" x2="138.2803" y2="116.7353"/>
    <line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7933" y1="118.5543" x2="138.2933" y2="118.5543"/>
  </g>
</g>
<g id="Strap_A-22" style="mix-blend-mode: multiply;">
	<rect x="44.6704" y="12.6964" fill="#E6E6E6" width="55.2006" height="194.6012"/>
  <path fill="lightgrey" d="M72.0607,10.983c0,0,28.4735,0.2987,29.6841,1.5093s1.5093,25.5419,1.5093,25.5419v11.1317H40.8673
    V38.0342c0,0,0.2992-24.3312,1.5092-25.5418S72.0607,10.983,72.0607,10.983z"/>
  <path fill="lightgrey" d="M72.0607,217.083c0,0,28.4735-0.2988,29.6841-1.5094s1.5093-33.1732,1.5093-33.1732v-11.1318H40.8673
    v11.1318c0,0,0.2987,31.9626,1.5094,33.1732S72.0607,217.083,72.0607,217.083z"/>
  <line fill="none" stroke="#6E6F71" stroke-width="0.862" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="10.1,4.787" x1="44.4604" y1="42.6762" x2="99.661" y2="42.6762"/>
  <line fill="none" stroke="#6E6F71" stroke-width="0.862" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="10.1,4.787" x1="44.4604" y1="177.7583" x2="99.661" y2="177.7583"/>
</g>
<g id="Case_A-22">

		<linearGradient id="SVGID_8_A-22" gradientUnits="userSpaceOnUse" x1="13.2073" y1="456.7242" x2="130.9147" y2="524.6825" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
		<stop  offset="0" style="stop-color:#E6E7E7"/>
		<stop  offset="1" style="stop-color:#929497"/>
	</linearGradient>
	<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M20.0214,139.1487c6.2692,12.4472,10.6706,25.75,13.0625,39.48
		c2.5204,1.44,5.119,2.7384,7.7838,3.8893l0.0124-20.082c0.0003-0.4698,0.3814-0.8505,0.8512-0.8502
		c0.1135,0.0001,0.2258,0.0229,0.3304,0.067l0.0013-0.0045c18.5407,10.7998,41.4554,10.8003,59.9966,0.0013l0.0007,0.0032
		c0.4332-0.1828,0.9325,0.0202,1.1153,0.4533c0.0441,0.1044,0.0668,0.2166,0.067,0.3299l0.0124,20.082
		c2.6646-1.1508,5.2631-2.4492,7.7831-3.8893c2.3927-13.7298,6.7941-27.0325,13.0625-39.48c9.9844-17.9923,9.9844-39.8617,0-57.854
		c-6.2685-12.4472-10.6698-25.7495-13.0625-39.4791c-2.5199-1.4403-5.1183-2.7388-7.7831-3.8893l-0.0124,20.082
		c0.0001,0.4694-0.3804,0.8501-0.8499,0.8501c-0.1142,0-0.2273-0.023-0.3324-0.0676v0.0039
		c-18.5405-10.8-41.4553-10.8003-59.996-0.0006l-0.0026-0.0033c-0.4317,0.1835-0.9304-0.0176-1.1139-0.4493
		c-0.0448-0.1054-0.0678-0.2187-0.0677-0.3332l-0.0124-20.082c-2.6649,1.1506-5.2636,2.4491-7.7838,3.8893
		c-2.3924,13.7297-6.7933,27.0324-13.0612,39.48c-9.9833,17.9903-9.9843,39.857-0.0026,57.8482"/>
	<g>

			<linearGradient id="SVGID_9_A-22" gradientUnits="userSpaceOnUse" x1="43.5694" y1="441.3437" x2="100.5556" y2="540.0469" gradientTransform="matrix(1 0 0 1 0.0027 -380.4725)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>

			<circle fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" cx="72.0652" cy="110.2228" r="56.9768"/>

			<linearGradient id="SVGID_10_A-22" gradientUnits="userSpaceOnUse" x1="116.2566" y1="516.2183" x2="27.8664" y2="465.1862" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>

			<circle fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" cx="72.0615" cy="110.221" r="51.0236"/>

			<linearGradient id="SVGID_11_A-22" gradientUnits="userSpaceOnUse" x1="47.4956" y1="448.1525" x2="96.6274" y2="533.2515" gradientTransform="matrix(1 0 0 1 2.429858e-05 -380.4812)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" cx="72.0615" cy="110.2208" r="49.1237"/>

			<linearGradient id="SVGID_12_A-22" gradientUnits="userSpaceOnUse" x1="96.16" y1="532.4417" x2="47.9632" y2="448.9623" gradientTransform="matrix(1 0 0 1 -0.0001 -380.4812)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" cx="72.0615" cy="110.2208" r="48.1888"/>

			<linearGradient id="SVGID_13_A-22" gradientUnits="userSpaceOnUse" x1="25.2895" y1="490.702" x2="118.8331" y2="490.702" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#C6C7C9"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.288" stroke-miterlimit="10" d="M118.8331,110.2204
			c0.0002,25.8314-20.94,46.772-46.7714,46.7722c-25.8313,0.0002-46.772-20.94-46.7722-46.7714s20.94-46.772,46.7714-46.7722h0.0001
			C97.8922,63.4491,118.8326,84.3892,118.8331,110.2204z"/>
	</g>
</g>
<g id="Day-ring_A-22">
	<path fill="#FFFFFF" d="M104.5098,110.2519c0,17.9253-14.5314,32.4567-32.4567,32.4567s-32.4567-14.5314-32.4567-32.4567
		s14.5314-32.4567,32.4567-32.4567S104.5098,92.3266,104.5098,110.2519z M72.0531,85.4489
		c-13.6984,0-24.8031,11.1047-24.8031,24.8031s11.1047,24.8031,24.8031,24.8031s24.8031-11.1047,24.8031-24.8031
		S85.7514,85.4489,72.0531,85.4489z"/>
	<g>
		<g>
			<path fill="#231F20" d="M98.3767,109.0465v-0.3027c0.2539-0.208,0.5215-0.3125,0.8018-0.3125s0.5186,0.0957,0.7139,0.2871
				s0.293,0.4238,0.293,0.7002c0,0.5459-0.4219,1.2988-1.2646,2.2588h1.5996v0.2363h-2.1836
				c1.0615-1.0225,1.5928-1.8525,1.5928-2.4902c0-0.2119-0.0742-0.3896-0.2217-0.5342s-0.3311-0.2168-0.5488-0.2168
				c-0.1445,0-0.2744,0.0293-0.3887,0.0889C98.655,108.8199,98.5242,108.9156,98.3767,109.0465z"/>
			<path fill="#231F20" d="M101.4675,110.1246c-0.3008-0.2031-0.4502-0.4619-0.4502-0.7754c0-0.2471,0.0898-0.4629,0.2705-0.6445
				c0.1807-0.1826,0.3926-0.2734,0.6367-0.2734c0.251,0,0.4668,0.0898,0.6475,0.2695s0.2705,0.3945,0.2705,0.6436
				c0,0.3232-0.1455,0.583-0.4375,0.7803c0.3379,0.2031,0.5068,0.4873,0.5068,0.8516c0,0.2754-0.0938,0.5078-0.2822,0.6973
				c-0.1875,0.1895-0.418,0.2842-0.6895,0.2842c-0.2764,0-0.5098-0.0928-0.7002-0.2803c-0.1914-0.1865-0.2871-0.4141-0.2871-0.6816
				C100.9529,110.6217,101.1247,110.3317,101.4675,110.1246z M102.656,110.9615c0-0.1953-0.0713-0.3623-0.2129-0.5
				s-0.3145-0.2061-0.5186-0.2061c-0.1982,0-0.3672,0.0713-0.5068,0.2148c-0.1387,0.1436-0.209,0.3154-0.209,0.5156
				c0,0.2021,0.0703,0.374,0.2119,0.5166c0.1406,0.1426,0.3145,0.2139,0.5195,0.2139c0.208,0,0.3789-0.0713,0.5137-0.2139
				S102.656,111.1793,102.656,110.9615z M101.2751,109.3444c0,0.1875,0.0635,0.3457,0.1904,0.4746
				c0.1279,0.1299,0.2842,0.1953,0.4697,0.1953c0.1865,0,0.3418-0.0654,0.4648-0.1953c0.123-0.1289,0.1846-0.292,0.1846-0.4863
				c0-0.1826-0.0645-0.3379-0.1924-0.4668s-0.2832-0.1934-0.4678-0.1934c-0.1797,0-0.333,0.0654-0.46,0.1963
				C101.3386,108.9986,101.2751,109.1578,101.2751,109.3444z"/>
		</g>
		<g>
			<path fill="#231F20" d="M97.5964,103.7716l-0.0625-0.2959c0.207-0.2549,0.4492-0.4111,0.7227-0.4678
				c0.2754-0.0566,0.5273-0.0107,0.7578,0.1377c0.2285,0.1479,0.3711,0.356,0.4277,0.6274
				c0.1094,0.5342-0.1504,1.3564-0.7852,2.4663l1.5684-0.3218l0.0469,0.2314l-2.1387,0.4395
				c0.834-1.2148,1.1875-2.1353,1.0586-2.7593c-0.043-0.208-0.1504-0.3667-0.3242-0.4785c-0.1738-0.1123-0.3672-0.1465-0.582-0.1025
				c-0.1406,0.0293-0.2617,0.0845-0.3633,0.165C97.823,103.4943,97.7136,103.6144,97.5964,103.7716z"/>
			<path fill="#231F20" d="M101.1394,106.0157l-0.1738-0.1523c0.6309-0.687,0.9375-1.3291,0.9199-1.9248
				c-0.2266,0.2217-0.457,0.3574-0.6875,0.4053c-0.2656,0.0542-0.5059,0.0112-0.7227-0.1299
				c-0.2168-0.1396-0.3516-0.3398-0.4043-0.6016c-0.0566-0.2725-0.0156-0.5151,0.127-0.7275
				c0.1406-0.2134,0.3496-0.3477,0.627-0.4043c0.3203-0.0659,0.5938-0.0127,0.8223,0.1602c0.2305,0.1719,0.3809,0.4409,0.457,0.8052
				C102.2761,104.2838,101.9538,105.1407,101.1394,106.0157z M101.8679,103.631c-0.0059-0.0527-0.0137-0.103-0.0234-0.1509
				c-0.0605-0.2891-0.1738-0.502-0.3418-0.6372c-0.168-0.1357-0.373-0.1792-0.6152-0.1294
				c-0.1992,0.041-0.3535,0.1421-0.4648,0.3013c-0.1113,0.1582-0.1445,0.3359-0.1055,0.5322
				c0.041,0.1992,0.1426,0.353,0.3027,0.4595c0.1602,0.1074,0.3398,0.1406,0.5391,0.1001
				C101.4421,104.048,101.6785,103.8898,101.8679,103.631z"/>
		</g>
		<g>
			<path fill="#231F20" d="M95.8455,98.5695l-0.0977-0.2261c0.127-0.2148,0.3184-0.3779,0.5781-0.4893
				c0.2754-0.1182,0.5332-0.1406,0.7734-0.0664c0.2402,0.0737,0.4092,0.2275,0.5088,0.459c0.0713,0.166,0.0859,0.335,0.043,0.5063
				c-0.042,0.1724-0.1445,0.3267-0.3066,0.4644l0.0039,0.0093c0.4678-0.0386,0.7871,0.1421,0.958,0.5415
				c0.1201,0.2793,0.1221,0.54,0.0049,0.7822c-0.1162,0.2432-0.3037,0.4199-0.5615,0.5303
				c-0.2617,0.1123-0.5264,0.1646-0.7949,0.1562l-0.0918-0.2163c0.2598,0.0073,0.5146-0.0425,0.7646-0.1499
				c0.2188-0.0938,0.3701-0.231,0.4521-0.4131c0.083-0.1826,0.0811-0.3735-0.0049-0.5737c-0.0928-0.2153-0.2383-0.356-0.4365-0.4214
				c-0.1982-0.0659-0.4248-0.042-0.6777,0.0713l-0.0947-0.2217c0.2314-0.0996,0.3936-0.2393,0.4863-0.4209
				c0.0908-0.1816,0.1006-0.356,0.0283-0.5254c-0.0723-0.167-0.2012-0.2788-0.3877-0.333
				c-0.1865-0.0547-0.3838-0.0376-0.5898,0.0508C96.1775,98.1813,95.991,98.3424,95.8455,98.5695z"/>
			<path fill="#231F20" d="M98.7908,96.7965c0.2832-0.1211,0.584-0.0815,0.8994,0.1191c0.3174,0.2002,0.5869,0.562,0.8105,1.083
				c0.208,0.4858,0.2803,0.916,0.2148,1.2896c-0.0654,0.3745-0.2402,0.623-0.5244,0.7456c-0.2988,0.1279-0.6055,0.0889-0.918-0.1172
				c-0.3135-0.2051-0.5703-0.543-0.7715-1.0107c-0.25-0.584-0.3311-1.0527-0.2412-1.4072S98.5271,96.9098,98.7908,96.7965z
				 M100.0769,99.8199c0.2354-0.1011,0.3682-0.3145,0.3975-0.6416s-0.043-0.6934-0.2178-1.1006
				c-0.1709-0.3994-0.3838-0.7002-0.6357-0.9053c-0.2529-0.2036-0.498-0.2559-0.7344-0.1543
				c-0.2236,0.0957-0.3525,0.3047-0.3867,0.6279c-0.0352,0.3232,0.0361,0.6909,0.2129,1.104
				c0.1797,0.4175,0.3955,0.7241,0.6484,0.9204C99.614,99.8663,99.8533,99.9156,100.0769,99.8199z"/>
		</g>
		<g>
			<path fill="#231F20" d="M93.0076,94.0206l-0.1406-0.2017c0.0801-0.2354,0.2363-0.4346,0.4678-0.5957
				c0.2471-0.1714,0.4951-0.2451,0.7451-0.2202c0.248,0.0234,0.4463,0.1401,0.5898,0.3467c0.1035,0.1484,0.1514,0.311,0.1445,0.4873
				c-0.0078,0.1772-0.0762,0.3491-0.207,0.5166l0.0059,0.0078c0.4502-0.1313,0.7988-0.0186,1.0469,0.3384
				c0.1738,0.249,0.2285,0.5039,0.1631,0.7646c-0.0654,0.2617-0.2129,0.4722-0.4434,0.6323
				c-0.2344,0.1631-0.4834,0.2676-0.7471,0.313l-0.1348-0.1934c0.2559-0.0449,0.4961-0.1455,0.7197-0.3008
				c0.1943-0.1357,0.3154-0.3003,0.3594-0.4956c0.0439-0.1948,0.0049-0.3823-0.1201-0.561
				c-0.1338-0.1924-0.3047-0.3003-0.5127-0.3247s-0.4248,0.0439-0.6494,0.2065l-0.1367-0.1982
				c0.207-0.144,0.3369-0.3135,0.3906-0.5103c0.0527-0.1963,0.0273-0.3691-0.0781-0.5205c-0.1035-0.1489-0.252-0.2319-0.4473-0.2476
				c-0.1934-0.0156-0.3828,0.04-0.5664,0.1685C93.2546,93.5734,93.1052,93.7692,93.0076,94.0206z"/>
			<path fill="#231F20" d="M95.6648,91.6564l1.9639,2.8213l-0.21,0.1465l-1.9639-2.8213L95.6648,91.6564z"/>
		</g>
		<g>
			<path fill="#231F20" d="M90.5701,88.1954l2.4912,2.3687l-0.1768,0.186l-2.4912-2.3687L90.5701,88.1954z"/>
		</g>
		<g>
			<path fill="#231F20" d="M85.6218,86.2057l-0.2559-0.1602c-0.043-0.3252,0.0098-0.6074,0.1582-0.8457
				c0.1484-0.2378,0.3555-0.3892,0.6211-0.4536s0.5156-0.0244,0.75,0.1216c0.4629,0.2891,0.8789,1.0444,1.248,2.2681l0.8457-1.3574
				l0.2012,0.125l-1.1562,1.8525c-0.3047-1.4414-0.7285-2.3311-1.2695-2.6685c-0.1816-0.1123-0.3711-0.1431-0.5723-0.0942
				c-0.1992,0.0483-0.3574,0.1655-0.4727,0.3511c-0.0762,0.1221-0.1211,0.248-0.1309,0.3765
				C85.5769,85.8497,85.5886,86.0118,85.6218,86.2057z"/>
		</g>
		<g>
			<path fill="#231F20" d="M80.4158,83.7775l-0.2305-0.0854c-0.0693-0.2393-0.0547-0.4912,0.043-0.7559
				c0.1045-0.2817,0.2656-0.4834,0.4854-0.6064c0.2178-0.123,0.4463-0.1396,0.6826-0.0522c0.1699,0.063,0.3027,0.1685,0.3965,0.3169
				c0.0957,0.1499,0.1377,0.3301,0.125,0.543l0.0098,0.0029c0.2949-0.3647,0.6455-0.4717,1.0527-0.3213
				c0.2852,0.1055,0.4756,0.2842,0.5703,0.5352c0.0967,0.252,0.0947,0.5098-0.002,0.7725
				c-0.0996,0.2676-0.2441,0.4956-0.4346,0.6836l-0.2207-0.0815c0.1846-0.1831,0.3232-0.4028,0.4189-0.6587
				c0.082-0.2227,0.0869-0.4268,0.0117-0.6113c-0.0752-0.1855-0.2148-0.3164-0.4199-0.3921
				c-0.2188-0.0815-0.4219-0.0723-0.6055,0.0259c-0.1846,0.0986-0.3232,0.2793-0.415,0.5405l-0.2256-0.0835
				c0.0869-0.2373,0.0977-0.4512,0.0293-0.6426s-0.1875-0.3184-0.3613-0.3828c-0.1699-0.063-0.3398-0.0464-0.5088,0.0518
				c-0.167,0.0977-0.291,0.252-0.3691,0.4629C80.363,83.2692,80.3513,83.5153,80.4158,83.7775z"/>
		</g>
		<g>
			<path fill="#231F20" d="M74.6838,81.0611l1.9268,0.2954l0.0723-0.4741l0.2041,0.0312l-0.0723,0.4741l1.3115,0.2007
				l-0.0391,0.2529l-1.3115-0.2007l-0.2373,1.5498l-0.083-0.0127l-1.7861-2.0215L74.6838,81.0611z M76.5715,81.6095l-1.4326-0.2197
				l1.249,1.418L76.5715,81.6095z"/>
		</g>
		<g>
			<path fill="#231F20" d="M68.7952,81.0748l0.2383-0.0127l0.0615,1.2148l1.0869-0.0557c-0.0195-0.0918-0.0317-0.1836-0.0361-0.2734
				c-0.0176-0.3428,0.064-0.623,0.2461-0.8408c0.1826-0.2178,0.436-0.335,0.7593-0.3516c0.3184-0.0156,0.5884,0.0762,0.8101,0.2764
				c0.2227,0.2012,0.3418,0.4609,0.3579,0.7783c0.0132,0.2656-0.0479,0.5449-0.1841,0.8379l-0.293,0.0146
				c0.1694-0.3291,0.2471-0.6123,0.2354-0.8496c-0.0127-0.2461-0.103-0.4443-0.272-0.5947
				c-0.1675-0.1514-0.3755-0.2207-0.6216-0.208c-0.2676,0.0137-0.4731,0.1084-0.6172,0.2852
				c-0.1426,0.1768-0.2075,0.4053-0.1934,0.6846c0.0078,0.1523,0.04,0.3086,0.0981,0.4688L68.8689,82.53L68.7952,81.0748z"/>
		</g>
		<g>
			<path fill="#231F20" d="M62.9978,82.5406l0.1396-0.1914c0.6865,0.582,1.3447,0.8516,1.9736,0.8105
				c-0.2344-0.1885-0.3838-0.4111-0.4502-0.6689c-0.0684-0.2646-0.0391-0.5088,0.0889-0.7314
				c0.127-0.2236,0.3203-0.3682,0.5771-0.4346c0.2715-0.0703,0.5186-0.04,0.7422,0.0928c0.2217,0.1318,0.3682,0.3359,0.4395,0.6104
				c0.0791,0.3076,0.0371,0.582-0.1279,0.8203c-0.1631,0.2393-0.4238,0.4053-0.7793,0.4971
				C64.7888,83.5563,63.9206,83.2877,62.9978,82.5406z M65.4099,83.1305c0.0605-0.0088,0.1182-0.0195,0.1729-0.0342
				c0.2705-0.0693,0.4678-0.1973,0.5938-0.3828c0.125-0.1846,0.1592-0.3877,0.1016-0.6104
				c-0.0518-0.2012-0.1592-0.3545-0.3223-0.459c-0.1641-0.1025-0.3389-0.1309-0.5283-0.0811
				c-0.2002,0.0518-0.3506,0.165-0.4502,0.3379c-0.1006,0.1729-0.125,0.3604-0.0723,0.5625
				C64.9724,82.7233,65.1404,82.9459,65.4099,83.1305z"/>
		</g>
		<g>
			<path fill="#231F20" d="M57.3567,84.3209l3.8188-0.1221l0.0137,0.2402l-3.4536,0.1133l0.8257,1.6836l-0.2139,0.1055
				L57.3567,84.3209z"/>
		</g>
		<g>
			<path fill="#231F20" d="M54.719,88.0641c0.0229,0.3613-0.0898,0.6387-0.3379,0.8301c-0.1953,0.1523-0.4204,0.2129-0.6748,0.1816
				c-0.2549-0.0312-0.4565-0.1445-0.6064-0.3369c-0.1533-0.1982-0.2148-0.4248-0.1831-0.6768s0.1465-0.4551,0.3438-0.6084
				c0.2554-0.1982,0.5503-0.2412,0.8848-0.1309c-0.0464-0.3916,0.0747-0.6992,0.3628-0.9219
				c0.2178-0.1689,0.4595-0.2373,0.7246-0.2041c0.2642,0.0322,0.4805,0.1562,0.647,0.3711c0.1685,0.2188,0.2383,0.46,0.2065,0.7256
				c-0.0303,0.2656-0.1519,0.4805-0.3633,0.6436C55.427,88.1666,55.093,88.2086,54.719,88.0641z M54.22,88.693
				c0.1479-0.1143,0.2339-0.2617,0.2583-0.4414c0.0249-0.1797-0.019-0.3428-0.1323-0.4902
				c-0.1147-0.1475-0.2612-0.2295-0.4395-0.248c-0.1772-0.0176-0.3438,0.0332-0.4971,0.1523
				c-0.1445,0.1113-0.2285,0.2578-0.252,0.4375c-0.0239,0.1797,0.0205,0.3428,0.1328,0.4883
				c0.1104,0.1426,0.2563,0.2236,0.437,0.2441C53.908,88.8551,54.0725,88.8082,54.22,88.693z M54.6536,86.6119
				c-0.1548,0.1201-0.2432,0.2783-0.2651,0.4746s0.0293,0.374,0.1538,0.5361c0.1216,0.1562,0.2817,0.2461,0.4805,0.2695
				c0.1987,0.0215,0.3774-0.0283,0.5356-0.1504c0.1602-0.125,0.2529-0.2852,0.2793-0.4844s-0.0234-0.3789-0.1489-0.541
				c-0.1274-0.1641-0.2886-0.2568-0.4839-0.2754C55.01,86.4215,54.8254,86.4781,54.6536,86.6119z"/>
		</g>
		<g>
			<path fill="#231F20" d="M51.8557,90.6656L51.842,90.897c-0.9307-0.0791-1.6265,0.0713-2.0859,0.4502
				c0.3145,0.043,0.5625,0.1426,0.7417,0.2959c0.2056,0.1768,0.3188,0.3936,0.3398,0.6504c0.022,0.2568-0.0547,0.4863-0.228,0.6885
				c-0.1812,0.2109-0.3994,0.3262-0.6538,0.3447c-0.2549,0.0186-0.4888-0.0645-0.7031-0.248
				c-0.248-0.2129-0.3735-0.4619-0.3774-0.749s0.1157-0.5713,0.3579-0.8535C49.7903,90.8278,50.6643,90.5572,51.8557,90.6656z
				 M49.5242,91.5494c-0.0381,0.0361-0.0732,0.0732-0.1055,0.1123c-0.1919,0.2227-0.291,0.4434-0.2954,0.6582
				c-0.0044,0.2168,0.0874,0.4043,0.2754,0.5664c0.1543,0.1318,0.3286,0.1934,0.522,0.1816
				c0.1929-0.0078,0.355-0.0898,0.4854-0.2422c0.1333-0.1543,0.1924-0.3271,0.1787-0.5195
				c-0.0132-0.1914-0.0972-0.3535-0.2515-0.4863C50.114,91.6315,49.8445,91.5416,49.5242,91.5494z"/>
		</g>
		<g>
			<path fill="#231F20" d="M47.1614,98.4645l1.6685-3.0059l0.2241,0.125l-1.6685,3.0059L47.1614,98.4645z"/>
			<path fill="#231F20" d="M45.0466,97.3414c-0.27-0.1494-0.4224-0.4111-0.457-0.7832c-0.0356-0.374,0.0854-0.8086,0.3608-1.3047
				c0.2563-0.4619,0.5527-0.7822,0.8877-0.959c0.3359-0.1777,0.6396-0.1914,0.9111-0.041c0.2842,0.1582,0.4404,0.4238,0.4692,0.7969
				c0.0293,0.374-0.0801,0.7832-0.3271,1.2295c-0.3086,0.5557-0.6299,0.9053-0.9653,1.0518S45.2976,97.4811,45.0466,97.3414z
				 M46.6497,94.4742c-0.2241-0.124-0.4741-0.0986-0.7505,0.0781c-0.2764,0.1777-0.5215,0.459-0.7368,0.8467
				c-0.2104,0.3789-0.3193,0.7314-0.3267,1.0566c-0.0063,0.3252,0.1021,0.5498,0.3276,0.6748
				c0.2124,0.1182,0.4565,0.0918,0.7334-0.0781c0.2764-0.1699,0.5239-0.4521,0.7422-0.8447
				c0.2202-0.3975,0.3306-0.7559,0.3306-1.0762C46.9695,94.8121,46.863,94.5934,46.6497,94.4742z"/>
		</g>
		<g>
			<path fill="#231F20" d="M45.2986,103.7184l1.0288-3.2793l0.2446,0.0762l-1.0293,3.2803L45.2986,103.7184z"/>
			<path fill="#231F20" d="M42.8933,102.9645l1.0293-3.2803l0.2446,0.0771l-1.0288,3.2793L42.8933,102.9645z"/>
		</g>
		<g>
			<path fill="#231F20" d="M44.531,109.2379l0.3477-3.4199l0.2549,0.0254l-0.3477,3.4199L44.531,109.2379z"/>
			<path fill="#231F20" d="M43.2346,108.5328l-0.0308,0.3018c-0.2739,0.1807-0.5508,0.2578-0.8301,0.2295
				c-0.2788-0.0283-0.5054-0.1484-0.6802-0.3584c-0.1753-0.21-0.2485-0.4502-0.2207-0.7256c0.0552-0.543,0.5503-1.25,1.4868-2.1191
				l-1.5918-0.1621l0.0239-0.2354l2.1719,0.2207c-1.1592,0.9102-1.7715,1.6816-1.8359,2.3164
				c-0.0215,0.2109,0.0337,0.3955,0.1665,0.5537c0.1318,0.1592,0.3066,0.249,0.5239,0.2715c0.1436,0.0146,0.2754-0.002,0.396-0.0488
				C42.9343,108.7301,43.074,108.6481,43.2346,108.5328z"/>
		</g>
		<g>
			<path fill="#231F20" d="M44.8894,114.7975l-0.3477-3.4199l0.2549-0.0264l0.3477,3.4199L44.8894,114.7975z"/>
			<path fill="#231F20" d="M43.3464,114.5289l0.0244,0.2451c-0.1846,0.167-0.417,0.2656-0.6973,0.2939
				c-0.2988,0.0303-0.5508-0.0259-0.7578-0.1685c-0.207-0.1421-0.3223-0.3394-0.3477-0.5903
				c-0.0186-0.1797,0.0176-0.3452,0.1094-0.4956c0.0928-0.1514,0.2363-0.2686,0.4326-0.3511l-0.001-0.0098
				c-0.458-0.104-0.709-0.3716-0.7529-0.8042c-0.0303-0.3018,0.0459-0.5513,0.2295-0.7476c0.1836-0.1973,0.415-0.3096,0.6943-0.3379
				c0.2842-0.0293,0.5527,0.001,0.8057,0.0894l0.0234,0.2334c-0.2451-0.0845-0.5039-0.1133-0.7754-0.0854
				c-0.2363,0.0239-0.4209,0.1099-0.5547,0.2583c-0.1338,0.1489-0.1895,0.332-0.167,0.5488c0.0234,0.2334,0.1211,0.4111,0.29,0.5327
				c0.1699,0.123,0.3936,0.1675,0.668,0.1348l0.0244,0.2402c-0.251,0.0254-0.4473,0.1104-0.5898,0.2563
				c-0.1416,0.1455-0.2031,0.3096-0.1846,0.4932c0.0186,0.1807,0.1084,0.3257,0.2705,0.4331
				c0.1621,0.1069,0.3545,0.1504,0.5781,0.1279C42.9128,114.8009,43.1394,114.7028,43.3464,114.5289z"/>
		</g>
		<g>
			<path fill="#231F20" d="M46.3621,120.1754l-1.0293-3.2803l0.2441-0.0771l1.0293,3.2803L46.3621,120.1754z"/>
			<path fill="#231F20" d="M43.4841,121.1246l-0.583-1.8594l-0.458,0.1436l-0.0625-0.1973l0.458-0.1436l-0.3965-1.2656
				l0.2441-0.0771l0.3965,1.2656l1.4961-0.4697l0.0254,0.0801l-1.0283,2.4941L43.4841,121.1246z M43.1453,119.1881l0.4336,1.3828
				l0.7227-1.7451L43.1453,119.1881z"/>
		</g>
		<g>
			<path fill="#231F20" d="M48.8855,125.1432l-1.668-3.0059l0.2246-0.124l1.668,3.0049L48.8855,125.1432z"/>
			<path fill="#231F20" d="M46.1921,126.6383l-0.1162-0.208l1.0635-0.5898l-0.5283-0.9512
				c-0.0742,0.0576-0.1514,0.1094-0.2295,0.1533c-0.3008,0.166-0.5879,0.2148-0.8633,0.1484
				c-0.2764-0.0684-0.4932-0.2441-0.6504-0.5273c-0.1543-0.2783-0.1914-0.5625-0.1094-0.8486
				c0.084-0.2891,0.2637-0.5098,0.542-0.6641c0.2324-0.1289,0.5098-0.1963,0.833-0.2041l0.1416,0.2559
				c-0.3701-0.0059-0.6582,0.0488-0.8662,0.1641c-0.2148,0.1191-0.3535,0.2881-0.4141,0.5059
				c-0.0615,0.2178-0.0332,0.4346,0.0869,0.6494c0.1299,0.2354,0.3057,0.3779,0.5283,0.4287
				c0.2207,0.0508,0.4551,0.0078,0.6992-0.1279c0.1338-0.0742,0.2598-0.1729,0.377-0.2949l0.7793,1.4033L46.1921,126.6383z"/>
		</g>
		<g>
			<path fill="#231F20" d="M52.3542,129.5006l-2.2383-2.6084l0.1943-0.167l2.2393,2.6084L52.3542,129.5006z"/>
			<path fill="#231F20" d="M50.2038,131.4068l-0.2334-0.041c0.2197-0.873,0.1719-1.583-0.1416-2.1299
				c-0.0664,0.2939-0.2012,0.5264-0.4023,0.6992c-0.207,0.1787-0.4395,0.2598-0.6953,0.2422
				c-0.2578-0.0156-0.4727-0.125-0.6445-0.3262c-0.1836-0.2129-0.2637-0.4482-0.2432-0.707
				c0.0205-0.2578,0.1396-0.4785,0.3545-0.6631c0.2412-0.208,0.5059-0.29,0.793-0.248c0.2861,0.042,0.5498,0.2031,0.7891,0.4814
				C50.3269,129.3512,50.4675,130.2496,50.2038,131.4068z M49.6706,128.9801c-0.0332-0.0488-0.0684-0.0957-0.1055-0.1387
				c-0.1826-0.2119-0.3848-0.334-0.6055-0.3652c-0.2217-0.0312-0.4189,0.0283-0.5938,0.1777
				c-0.1582,0.1367-0.248,0.2998-0.2695,0.4912c-0.0195,0.1924,0.0332,0.3623,0.1602,0.5107
				c0.1348,0.1572,0.3008,0.2432,0.502,0.2559c0.1992,0.0137,0.3779-0.0479,0.5361-0.1836
				C49.4988,129.5533,49.6238,129.3043,49.6706,128.9801z"/>
		</g>
		<g>
			<path fill="#231F20" d="M56.6355,133.0709l-2.7188-2.1045l0.1562-0.2021l2.7188,2.1045L56.6355,133.0709z"/>
			<path fill="#231F20" d="M54.4753,135.8609l-1.793-3.373l0.2109-0.1191l1.623,3.0508l1.1465-1.4824l0.1895,0.1455
				L54.4753,135.8609z"/>
		</g>
		<g>
			<path fill="#231F20" d="M61.5437,135.7086l-3.0859-1.5137l0.1133-0.2305l3.0859,1.5137L61.5437,135.7086z"/>
			<path fill="#231F20" d="M59.2136,136.7164c0.3145-0.1797,0.6133-0.2002,0.8945-0.0625c0.2217,0.1094,0.375,0.2852,0.459,0.5264
				c0.084,0.2432,0.0723,0.4736-0.0352,0.6934c-0.1104,0.2246-0.2861,0.3789-0.5264,0.4619
				c-0.2412,0.082-0.4736,0.0693-0.6973-0.041c-0.29-0.1426-0.46-0.3867-0.5078-0.7363c-0.3311,0.2139-0.6602,0.2402-0.9873,0.0801
				c-0.2471-0.1211-0.415-0.3076-0.502-0.5605c-0.0879-0.252-0.0713-0.5,0.0479-0.7441c0.1221-0.248,0.3076-0.416,0.5605-0.5049
				c0.252-0.0898,0.498-0.0752,0.7383,0.043C58.9939,136.0358,59.1785,136.318,59.2136,136.7164z M57.9382,137.4156
				c0.1758,0.0859,0.3574,0.0957,0.543,0.0283c0.1855-0.0664,0.3232-0.1914,0.4131-0.374c0.0869-0.1777,0.0977-0.3613,0.0303-0.5498
				s-0.1914-0.3271-0.3711-0.415c-0.1816-0.0889-0.3662-0.1016-0.5566-0.0371c-0.1895,0.0635-0.3301,0.1875-0.4209,0.3721
				c-0.0908,0.1865-0.1025,0.3721-0.0342,0.5557S57.7429,137.319,57.9382,137.4156z M59.9988,136.8883
				c-0.168-0.083-0.3379-0.0957-0.5098-0.0381c-0.1729,0.0566-0.3008,0.168-0.3828,0.335c-0.082,0.168-0.0918,0.3359-0.0293,0.5029
				s0.1816,0.2949,0.3555,0.3809c0.1641,0.0801,0.332,0.0908,0.5039,0.0332c0.1719-0.0586,0.2988-0.1699,0.3799-0.335
				c0.0791-0.1621,0.0869-0.3291,0.0264-0.5C60.281,137.0963,60.1658,136.9703,59.9988,136.8883z"/>
		</g>
		<g>
			<path fill="#231F20" d="M66.8816,137.3033l-3.3271-0.8613l0.0645-0.248l3.3271,0.8613L66.8816,137.3033z"/>
			<path fill="#231F20" d="M63.0447,138.232l0.2139-0.0898c0.3389,0.8711,0.7812,1.4287,1.3242,1.6738
				c-0.1006-0.3008-0.1211-0.5674-0.0625-0.7959c0.0684-0.2617,0.2129-0.459,0.4346-0.5918
				c0.2207-0.1318,0.4609-0.165,0.7188-0.0986c0.2695,0.0703,0.4697,0.2148,0.5977,0.4365
				c0.1289,0.2197,0.1572,0.4668,0.0869,0.7393c-0.082,0.3164-0.251,0.5391-0.5068,0.6699
				c-0.2549,0.1289-0.5635,0.1475-0.9238,0.0537C64.0994,140.0152,63.4724,139.3492,63.0447,138.232z M64.866,139.9361
				c0.0498,0.0176,0.0977,0.0322,0.1465,0.0449c0.2852,0.0742,0.5264,0.0664,0.7217-0.0244
				c0.1963-0.0918,0.3242-0.2568,0.3867-0.4961c0.0508-0.1973,0.0283-0.3809-0.0664-0.5498
				c-0.0928-0.1689-0.2373-0.2783-0.4307-0.3291c-0.1982-0.0508-0.3789-0.0283-0.5459,0.0684s-0.2754,0.2432-0.3262,0.4404
				C64.6794,139.3697,64.7175,139.652,64.866,139.9361z"/>
		</g>
		<g>
			<path fill="#231F20" d="M71.9236,136.6041l0.3027,0.0146c0.1953,0.2646,0.2861,0.5371,0.2725,0.8174
				c-0.0146,0.2803-0.1221,0.5127-0.3232,0.6982c-0.2021,0.1855-0.4385,0.2715-0.7148,0.2568
				c-0.5449-0.0273-1.2754-0.4863-2.1914-1.377l-0.0811,1.5977l-0.2363-0.0127l0.1104-2.1807
				c0.9678,1.1123,1.7705,1.6846,2.4072,1.7168c0.2119,0.0107,0.3926-0.0537,0.5439-0.1943
				c0.1523-0.1396,0.2334-0.3193,0.2451-0.5371c0.0068-0.1436-0.0156-0.2754-0.0693-0.3926
				C72.1365,136.8941,72.0476,136.7574,71.9236,136.6041z"/>
			<path fill="#231F20" d="M72.3591,140.1832c-0.0156,0.3086-0.1846,0.5605-0.5039,0.7559
				c-0.3193,0.1963-0.7627,0.2793-1.3291,0.251c-0.5273-0.0273-0.9463-0.1523-1.252-0.375
				c-0.3076-0.2236-0.4541-0.4902-0.4385-0.7998c0.0166-0.3242,0.1865-0.582,0.5098-0.7725
				c0.3213-0.1904,0.7383-0.2734,1.2471-0.2471c0.6348,0.0322,1.0908,0.166,1.3701,0.4033
				C72.241,139.6354,72.3738,139.8971,72.3591,140.1832z M69.0779,140.0074c-0.0127,0.2559,0.1201,0.4688,0.4004,0.6387
				c0.2812,0.1709,0.6416,0.2666,1.085,0.2891c0.4326,0.0225,0.7969-0.0352,1.0918-0.1719c0.2949-0.1377,0.4502-0.335,0.4629-0.5918
				c0.0127-0.2422-0.1191-0.4502-0.3945-0.623c-0.2744-0.1738-0.6357-0.2715-1.084-0.2949
				c-0.4531-0.0225-0.8242,0.0361-1.1123,0.1768C69.24,139.5709,69.0906,139.7643,69.0779,140.0074z"/>
		</g>
		<g>
			<path fill="#231F20" d="M77.2302,136.0904l0.2988-0.0459c0.2437,0.2197,0.3877,0.4688,0.4302,0.7461
				c0.0425,0.2764-0.0161,0.5264-0.1753,0.748c-0.1597,0.2227-0.3745,0.3545-0.6479,0.3965c-0.54,0.082-1.3481-0.2207-2.4238-0.9082
				l0.2422,1.5811l-0.2344,0.0352l-0.3306-2.1572c1.1714,0.8945,2.0723,1.293,2.7031,1.1963
				c0.209-0.0322,0.3735-0.1318,0.4946-0.2998c0.1206-0.168,0.1641-0.3594,0.1309-0.5752c-0.022-0.1426-0.0708-0.2666-0.147-0.3701
				C77.4963,136.3316,77.3816,136.2164,77.2302,136.0904z"/>
			<path fill="#231F20" d="M78.3513,139.6412l-3.3984,0.5205l-0.0391-0.2539l3.3984-0.5205L78.3513,139.6412z"/>
		</g>
		<g>
			<path fill="#231F20" d="M82.3269,134.5191l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7695
				c-0.1113,0.249-0.2969,0.4219-0.5557,0.5176c-0.5117,0.1895-1.3643,0.0557-2.5576-0.4023l0.5557,1.501l-0.2217,0.082
				l-0.7578-2.0479c1.3271,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936
				s0.0879-0.3857,0.0117-0.5898c-0.0488-0.1357-0.1221-0.2471-0.2168-0.333C82.6355,134.7018,82.4997,134.6119,82.3269,134.5191z"
				/>
			<path fill="#231F20" d="M83.2019,136.8824l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7686
				c-0.1113,0.25-0.2959,0.4229-0.5557,0.5186c-0.5117,0.1895-1.3643,0.0557-2.5571-0.4023l0.5557,1.5l-0.2217,0.082l-0.7583-2.0469
				c1.3276,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936s0.0879-0.3857,0.0127-0.5898
				c-0.0498-0.1357-0.1221-0.2471-0.2178-0.334S83.3757,136.9752,83.2019,136.8824z"/>
		</g>
		<g>
			<path fill="#231F20" d="M86.9988,131.9557l0.2578-0.1602c0.3105,0.1055,0.541,0.2773,0.6895,0.5156s0.1934,0.4902,0.1338,0.7578
				c-0.0596,0.2656-0.2041,0.4727-0.4385,0.6182c-0.4639,0.2891-1.3262,0.3291-2.5859,0.1221l0.8457,1.3574l-0.2012,0.125
				l-1.1543-1.8535c1.4297,0.3613,2.4141,0.3711,2.9551,0.0352c0.1807-0.1133,0.293-0.2695,0.3359-0.4707
				c0.0449-0.2021,0.0098-0.3955-0.1055-0.5811c-0.0762-0.1221-0.1699-0.2168-0.2812-0.2822
				C87.3386,132.0729,87.1882,132.0113,86.9988,131.9557z"/>
			<path fill="#231F20" d="M88.5359,134.1412l0.209-0.1299c0.2305,0.0918,0.4219,0.2568,0.5703,0.4971
				c0.1592,0.2549,0.2207,0.5059,0.1826,0.7539c-0.0361,0.248-0.1621,0.4395-0.376,0.5723
				c-0.1533,0.0957-0.3184,0.1357-0.4941,0.1201c-0.1758-0.0166-0.3447-0.0938-0.5049-0.2334l-0.0088,0.0049
				c0.1094,0.4561-0.0215,0.7998-0.3906,1.0293c-0.2578,0.1611-0.5146,0.2021-0.7715,0.124
				c-0.2578-0.0781-0.4609-0.2363-0.6094-0.4746c-0.1504-0.2422-0.2422-0.4961-0.2754-0.7617l0.2002-0.125
				c0.0322,0.2578,0.1201,0.5029,0.2646,0.7344c0.125,0.2012,0.2832,0.3301,0.4766,0.3838
				c0.1924,0.0537,0.3809,0.0225,0.5664-0.0928c0.1982-0.123,0.3145-0.2891,0.3496-0.4941c0.0352-0.207-0.0225-0.4268-0.1729-0.6592
				l0.2041-0.1279c0.1338,0.2148,0.2969,0.3535,0.4902,0.417s0.3672,0.0459,0.5234-0.0518
				c0.1543-0.0957,0.2451-0.2402,0.2715-0.4336c0.0244-0.1914-0.0215-0.3848-0.1406-0.5742
				C88.9705,134.4108,88.782,134.2506,88.5359,134.1412z"/>
		</g>
		<g>
			<path fill="#231F20" d="M91.0622,128.5006l0.2197-0.209c0.3262,0.041,0.5859,0.1631,0.7793,0.3662
				c0.1934,0.2041,0.2871,0.4424,0.2832,0.7158s-0.1055,0.5039-0.3057,0.6934c-0.3955,0.377-1.2314,0.5898-2.5088,0.6406
				l1.1025,1.1602l-0.1709,0.1621l-1.5039-1.582c1.4717,0.0645,2.4395-0.123,2.9014-0.5625
				c0.1533-0.1455,0.2314-0.3213,0.2344-0.5283c0.0029-0.2061-0.0703-0.3887-0.2207-0.5469c-0.0986-0.1045-0.21-0.1787-0.332-0.2207
				S91.2585,128.5182,91.0622,128.5006z"/>
			<path fill="#231F20" d="M94.3943,131.1119l-1.4131,1.3438l0.3311,0.3477l-0.1494,0.1426l-0.332-0.3477l-0.9609,0.9141
				l-0.1758-0.1855l0.9609-0.9141l-1.0801-1.1367l0.0605-0.0576l2.6934-0.1758L94.3943,131.1119z M92.8054,132.2701l1.0498-0.998
				l-1.8857,0.1191L92.8054,132.2701z"/>
		</g>
		<g>
			<path fill="#231F20" d="M94.3474,124.3024l0.1729-0.249c0.3262-0.0264,0.6064,0.042,0.8369,0.2021
				c0.2295,0.1602,0.3701,0.374,0.4209,0.6426c0.0518,0.2695-0.001,0.5156-0.1582,0.7422
				c-0.3125,0.4482-1.0889,0.8252-2.3291,1.1309l1.3135,0.9141l-0.1357,0.1943l-1.792-1.2471
				c1.4551-0.2324,2.3652-0.6113,2.7305-1.1348c0.1211-0.1738,0.1621-0.3613,0.123-0.5645s-0.1484-0.3672-0.3281-0.4922
				c-0.1172-0.082-0.2402-0.1318-0.3691-0.1484C94.7058,124.275,94.5427,124.2789,94.3474,124.3024z"/>
			<path fill="#231F20" d="M98.1531,126.2555l-0.1367,0.1963l-0.998-0.6943l-0.6211,0.8926c0.0859,0.041,0.166,0.0879,0.2393,0.1387
				c0.2822,0.1963,0.4521,0.4326,0.5146,0.709c0.0586,0.2783-0.002,0.5508-0.1875,0.8164
				c-0.1816,0.2617-0.4209,0.4189-0.7148,0.4707c-0.2949,0.0537-0.5723-0.0117-0.834-0.1934
				c-0.2188-0.1523-0.4014-0.3711-0.5498-0.6572l0.167-0.2412c0.1572,0.3359,0.334,0.5703,0.5293,0.707
				c0.2012,0.1406,0.4141,0.1895,0.6357,0.1484c0.2227-0.041,0.4053-0.1621,0.5449-0.3652
				c0.1533-0.2197,0.2041-0.4394,0.1533-0.6621c-0.0527-0.2207-0.1934-0.4121-0.4238-0.5723
				c-0.125-0.0869-0.2695-0.1562-0.4307-0.209l0.917-1.3164L98.1531,126.2555z"/>
		</g>
		<g>
			<path fill="#231F20" d="M96.7195,119.527l0.1191-0.2793c0.3145-0.0898,0.6025-0.082,0.8604,0.0293s0.4385,0.293,0.542,0.5449
				c0.1045,0.2539,0.1025,0.5059-0.0068,0.7598c-0.2148,0.502-0.8994,1.0273-2.0527,1.5762l1.4697,0.6309l-0.0928,0.2168
				l-2.0068-0.8594c1.3789-0.5215,2.1943-1.0742,2.4453-1.6621c0.084-0.1934,0.0859-0.3867,0.0078-0.5781
				c-0.0791-0.1895-0.2188-0.3281-0.4189-0.4141c-0.1328-0.0566-0.2637-0.082-0.3926-0.0723
				C97.0642,119.4274,96.906,119.4645,96.7195,119.527z"/>
			<path fill="#231F20" d="M100.6677,120.5524l0.0664,0.2266c-0.8809,0.1875-1.4971,0.543-1.8496,1.0645
				c0.293-0.0703,0.5605-0.0508,0.8047,0.0527c0.252,0.1094,0.4268,0.2812,0.5244,0.5195c0.0986,0.2363,0.0957,0.4785-0.0098,0.7227
				c-0.1104,0.2578-0.2861,0.4336-0.5273,0.5293c-0.2402,0.0938-0.4912,0.0859-0.752-0.0273
				c-0.292-0.125-0.4824-0.3262-0.5713-0.6016s-0.0605-0.584,0.085-0.9219C98.7693,121.3453,99.5124,120.8238,100.6677,120.5524z
				 M98.7244,122.0973c-0.0293,0.0527-0.0557,0.1055-0.0781,0.1582c-0.1104,0.2559-0.1299,0.4902-0.0605,0.7031
				s0.209,0.3633,0.4209,0.4551c0.1914,0.082,0.377,0.0898,0.5586,0.0254c0.1826-0.0664,0.3115-0.1895,0.3887-0.3691
				c0.082-0.1895,0.085-0.377,0.0088-0.5625s-0.21-0.3184-0.4014-0.4004C99.3152,122.0016,99.0349,121.9977,98.7244,122.0973z"/>
		</g>
		<g>
			<path fill="#231F20" d="M98.0808,114.3717l0.0605-0.2969c0.291-0.1523,0.5742-0.2012,0.8496-0.1445
				c0.2744,0.0566,0.4883,0.1982,0.6406,0.4248s0.2012,0.4746,0.1465,0.7451c-0.1104,0.5352-0.6748,1.1875-1.6943,1.958
				l1.5674,0.3223l-0.0479,0.2314l-2.1377-0.4395c1.2451-0.7891,1.9316-1.4941,2.0605-2.1191
				c0.043-0.208,0.0059-0.3965-0.1094-0.5684c-0.1162-0.1709-0.2803-0.2783-0.4941-0.3223
				c-0.1416-0.0293-0.2744-0.0273-0.3984,0.0088C98.3992,114.2057,98.2517,114.2731,98.0808,114.3717z"/>
			<path fill="#231F20" d="M102.7878,114.7565l-2.2402,3.0947l-0.1992-0.1367l2.0234-2.7998l-1.8359-0.3779l0.0488-0.2334
				L102.7878,114.7565z"/>
		</g>
	</g>
</g>
<g id="Dial_A-22">
	<g id="Bkgd">
		<path fill="#FFFFFF" stroke="#231F20" stroke-width="0.1" d="M71.9704,63.4582c-0.0002,0-0.0005,0-0.0008,0c-25.8268,0.0006-46.763,20.9379-46.7624,46.7646
			c0.0006,25.8268,20.9378,46.7631,46.7646,46.7625s46.763-20.9379,46.7624-46.7646
			C118.7333,84.3943,97.7967,63.4584,71.9704,63.4582z M104.4269,112.9829h-7.653v-5.5274h7.653V112.9829z"/>
		<g id="Sec-Track">
			<g id="Applied_Indexes">
				<rect x="69.7702" y="64.8955" fill="#231F20" width="4.4048" height="2.937"/>
				<rect x="69.7696" y="152.6514" fill="#231F20" width="4.4055" height="2.9373"/>
				<rect x="26.6262" y="108.0403" fill="#231F20" width="2.9366" height="4.4045"/>
				<rect x="114.3821" y="108.0403" fill="#231F20" width="2.937" height="4.4045"/>
			</g>
			<g id="Tick_Marks">
				<g>
					<path fill="#231F20" d="M62.9011,154.0875l-0.1211-0.1113c-0.0752-0.0713-0.126-0.1367-0.1523-0.1943
						c-0.0264-0.0586-0.0322-0.1221-0.0186-0.1895c0.0215-0.0996,0.0723-0.1738,0.1543-0.2217
						c0.083-0.0479,0.1787-0.0605,0.29-0.0381c0.1064,0.0225,0.1973,0.0713,0.2734,0.1504l-0.042,0.2061
						c-0.0732-0.1064-0.1631-0.1719-0.2686-0.1934c-0.0596-0.0127-0.1113-0.0078-0.1553,0.0117s-0.0703,0.0508-0.0791,0.0938
						c-0.0078,0.0371-0.001,0.0752,0.0195,0.1152c0.0215,0.0381,0.0596,0.083,0.1152,0.1318l0.1211,0.1123
						c0.1367,0.124,0.1895,0.2578,0.1602,0.4014c-0.0205,0.1016-0.0732,0.1768-0.1533,0.2266
						c-0.082,0.0498-0.1768,0.0625-0.2871,0.04c-0.125-0.0264-0.2305-0.0879-0.3184-0.1865l0.0479-0.2305
						c0.0723,0.1445,0.1729,0.2305,0.3027,0.2568c0.0566,0.0117,0.1074,0.0059,0.1514-0.0176
						c0.0449-0.0234,0.0723-0.0605,0.082-0.1074C63.0388,154.2652,62.9978,154.1813,62.9011,154.0875z"/>
				</g>
				<g>
					<path fill="#231F20" d="M65.2043,153.7438l0.1821,0.0322l-0.7393,1.1953l-0.04-0.0068l-0.2383-1.1133l-0.6016,0.9678
						l-0.04-0.0068l-0.2925-1.374l0.1841,0.0312l0.2007,0.9434l0.5068-0.8203l0.1724,0.0293l0.2046,0.9443L65.2043,153.7438z"/>
				</g>
				<g>
					<path fill="#231F20" d="M65.5144,153.7848l0.1846,0.0273l-0.186,1.2842l-0.1846-0.0273L65.5144,153.7848z"/>
				</g>
				<g>
					<path fill="#231F20" d="M66.2082,154.6402l-0.1299-0.1035c-0.0806-0.0654-0.1362-0.126-0.168-0.1826
						c-0.0293-0.0566-0.04-0.1191-0.0312-0.1865c0.0132-0.1016,0.0586-0.1787,0.1372-0.2334
						c0.0776-0.0537,0.1743-0.0732,0.2866-0.0586c0.1074,0.0137,0.2012,0.0557,0.2832,0.1279l-0.0269,0.209
						c-0.0811-0.1006-0.1753-0.1582-0.2817-0.1719c-0.0605-0.0078-0.1108,0-0.1533,0.0225
						c-0.043,0.0225-0.0669,0.0557-0.0728,0.0986c-0.0049,0.0391,0.0049,0.0771,0.0288,0.1143
						c0.0244,0.0371,0.0654,0.0781,0.124,0.124l0.1299,0.1006c0.1445,0.1152,0.208,0.2441,0.1895,0.3887
						c-0.0137,0.1035-0.0586,0.1836-0.1362,0.2383c-0.0776,0.0557-0.1719,0.0762-0.2822,0.0615
						c-0.127-0.0166-0.2378-0.0703-0.3315-0.1621l0.0303-0.2334c0.0825,0.1387,0.1895,0.2168,0.3203,0.2334
						c0.0576,0.0078,0.1074-0.002,0.1509-0.0293c0.042-0.0273,0.0659-0.0645,0.0723-0.1133
						C66.3577,154.8063,66.3113,154.7252,66.2082,154.6402z"/>
				</g>
				<g>
					<path fill="#231F20" d="M67.0872,154.7457l-0.1309-0.0996c-0.082-0.0635-0.1387-0.123-0.1704-0.1797
						c-0.0317-0.0557-0.0435-0.1182-0.0361-0.1865c0.0112-0.1016,0.0547-0.1787,0.1333-0.2354
						c0.0771-0.0557,0.1719-0.0771,0.2842-0.0645c0.1079,0.0117,0.2036,0.0518,0.2866,0.123l-0.0229,0.21
						c-0.083-0.0996-0.1782-0.1553-0.2852-0.167c-0.0601-0.0068-0.1118,0.001-0.1533,0.0254
						c-0.0415,0.0234-0.0649,0.0576-0.0698,0.1006c-0.0044,0.0391,0.0059,0.0762,0.0308,0.1133s0.0669,0.0781,0.1265,0.1211
						l0.1313,0.0996c0.1475,0.1104,0.2129,0.2383,0.1973,0.3848c-0.0112,0.1025-0.0557,0.1826-0.1313,0.2393
						c-0.0767,0.0586-0.1699,0.0791-0.2808,0.0674c-0.1274-0.0137-0.2393-0.0645-0.3354-0.1553l0.0259-0.2334
						c0.0859,0.1367,0.1938,0.2119,0.3252,0.2266c0.0581,0.0059,0.1079-0.0039,0.1499-0.0322
						c0.0415-0.0283,0.0654-0.0674,0.0708-0.1162C67.2414,154.9108,67.1926,154.8287,67.0872,154.7457z"/>
				</g>
				<g>
					<path fill="#231F20" d="M77.6365,153.9l0.1729-0.0195l0.1523,1.2881l-0.1855,0.0215l-0.1182-1.002l-0.3379,0.5449
						l-0.0342,0.0039l-0.459-0.4512l0.1182,1.002l-0.1846,0.0225l-0.1523-1.2881l0.1748-0.0205l0.4902,0.4785L77.6365,153.9z"/>
				</g>
				<g>
					<path fill="#231F20" d="M78.5046,153.7711l0.1299-0.0195l0.7686,1.2041l-0.1885,0.0283l-0.2275-0.3555l-0.5479,0.082
						l-0.1035,0.4053l-0.1875,0.0283L78.5046,153.7711z M78.8865,154.4772l-0.2754-0.4336l-0.123,0.4932L78.8865,154.4772z"/>
				</g>
				<g>
					<path fill="#231F20" d="M79.5798,154.9225l-0.2305-1.2744l0.4297-0.0781c0.1738-0.0322,0.3154-0.0312,0.4268,0.0039
						c0.1104,0.0332,0.2051,0.0947,0.2832,0.1855c0.0781,0.0898,0.1279,0.1953,0.1494,0.3145
						c0.0156,0.0859,0.0137,0.1699-0.0059,0.2539c-0.0176,0.084-0.0527,0.1621-0.1025,0.2314
						c-0.0518,0.0713-0.1152,0.1309-0.1914,0.1768c-0.0449,0.0273-0.0869,0.0479-0.126,0.0625
						c-0.0391,0.0137-0.1152,0.0303-0.2285,0.0508L79.5798,154.9225z M79.7898,153.7359l-0.2285,0.042l0.1719,0.9492l0.2344-0.043
						c0.0908-0.0166,0.1611-0.0361,0.209-0.0566c0.0488-0.0225,0.0879-0.0459,0.1182-0.0713
						c0.0312-0.0244,0.0566-0.0547,0.0801-0.0879c0.0732-0.1074,0.0977-0.2305,0.0723-0.3701
						c-0.0254-0.1367-0.0908-0.2412-0.1992-0.3096c-0.04-0.0273-0.084-0.0469-0.1318-0.0596
						c-0.0488-0.0117-0.0928-0.0186-0.1338-0.0176C79.9412,153.7115,79.8767,153.7203,79.7898,153.7359z"/>
				</g>
				<g>
					<path fill="#231F20" d="M80.7273,153.3902l0.7197-0.1504l0.0342,0.1621l-0.5391,0.1133l0.0811,0.3867l0.5205-0.1084
						l0.0342,0.1621l-0.5205,0.1084l0.083,0.3945l0.5557-0.1152l0.0342,0.1621l-0.7383,0.1543L80.7273,153.3902z"/>
				</g>
				<g id="Short_Tick">

						<line fill="none" stroke="#231F20" stroke-width="0.2582" stroke-miterlimit="10" x1="62.8938" y1="152.9511" x2="63.1015" y2="151.9738"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2582" stroke-miterlimit="10" x1="67.4083" y1="153.6659" x2="67.5122" y2="152.6729"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2582" stroke-miterlimit="10" x1="76.536" y1="153.6672" x2="76.4318" y2="152.6719"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2582" stroke-miterlimit="10" x1="81.0508" y1="152.9511" x2="80.8418" y2="151.9738"/>
				</g>
				<g id="Arcs">
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="62.5456" y1="65.8445" x2="63.1191" y2="68.5413"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="57.9611" y1="67.0728" x2="58.8132" y2="69.6954"/>
						</g>
						<path id="Arc" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M54.6525,71.2924
							l-1.1108-2.4947c4.329-1.9278,8.935-3.1606,13.6482-3.6527l0.3314,2.6988"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="41.6329" y1="76.4989" x2="43.4783" y2="78.5483"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="38.2771" y1="79.8557" x2="40.3265" y2="81.7011"/>
						</g>
						<path id="Arc-2" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M37.5207,85.1643
							l-2.2142-1.6091c2.8012-3.8419,6.1861-7.222,10.0321-10.0177l1.6032,2.2057"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.8498" y1="96.1831" x2="31.4723" y2="97.0355"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.6208" y1="100.7682" x2="30.3186" y2="101.3404"/>
						</g>
						<path id="Arc-3" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M29.6211,105.7439
							l-2.7453-0.289c0.4946-4.7325,1.7361-9.3568,3.6781-13.7007l2.5158,1.12"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.6208" y1="119.6222" x2="30.3186" y2="119.0481"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.8491" y1="124.2054" x2="31.4717" y2="123.354"/>
						</g>
						<path id="Arc-4" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M29.6211,114.6466
							l-2.7551,0.289c0.4847,4.7357,1.7172,9.3646,3.6517,13.7143l2.5513-1.1345"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="38.2751" y1="140.5344" x2="40.3256" y2="138.689"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="41.6313" y1="143.8902" x2="43.4773" y2="141.8408"/>
						</g>
						<path id="Arc-5" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M37.5204,135.2248
							l-2.261,1.64c2.7992,3.853,6.1846,7.2437,10.0331,10.049l1.6484-2.2681"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="102.3139" y1="143.8922" x2="100.4685" y2="141.8428"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="105.6688" y1="140.5364" x2="103.6203" y2="138.69"/>
						</g>
						<path id="Arc-6" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M106.4245,135.2267
							l2.26,1.6384c-2.7999,3.8534-6.1861,7.2445-10.0354,10.05l-1.6449-2.2672"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.3251" y1="119.6232" x2="113.627" y2="119.0491"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.0968" y1="124.2074" x2="112.4742" y2="123.354"/>
						</g>
						<path id="Arc-7" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M110.8765,127.5164
							l2.55,1.1335c0.6428-1.4469,1.2092-2.9265,1.6969-4.4328c0.4887-1.5075,0.8968-3.04,1.2225-4.5909
							c0.3274-1.5544,0.7206-4.6906,0.7206-4.6906l-2.7418-0.289"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.3245" y1="100.7682" x2="113.627" y2="101.3404"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.0961" y1="96.1831" x2="112.4742" y2="97.0355"/>
						</g>
						<path id="Arc-8" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M110.8765,92.8741
							l2.5132-1.1219c1.938,4.3381,3.1789,8.9549,3.6771,13.68l-2.7418,0.3115"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="105.6688" y1="79.8547" x2="103.619" y2="81.6991"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="102.3126" y1="76.4989" x2="100.4672" y2="78.5474"/>
						</g>
						<path id="Arc-9" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M106.4245,85.1634
							l2.2308-1.6209c0,0-1.988-2.5444-3.0705-3.7385c-2.105-2.3243-4.4445-4.4249-6.9812-6.2684l-1.6006,2.2066"/>
					</g>
					<g>
						<g>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="85.9841" y1="67.0709" x2="85.1314" y2="69.6934"/>

								<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="81.3997" y1="65.8426" x2="80.8256" y2="68.5394"/>
						</g>
						<path id="Arc-10" fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M89.2928,71.2908
							l1.11-2.4927c-4.3437-1.9333-8.9656-3.1681-13.6948-3.6585l-0.2851,2.7026"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="85.9848" y1="153.3196" x2="85.1327" y2="150.6967"/>
						<path fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M82.2165,152.9092l0.3443,1.4362
							c1.1652-0.2779,2.3124-0.601,3.4415-0.9692c1.5093-0.4903,2.9915-1.0601,4.4406-1.707l-1.1482-2.57"/>
					</g>
					<g>
						<path fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" d="M61.7293,152.9072l-0.3463,1.4382
							c-1.1658-0.2779-2.3136-0.601-3.4434-0.9692c-1.5067-0.4902-2.9866-1.0593-4.4334-1.7051l1.1446-2.5738"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="57.9598" y1="153.3183" x2="58.8122" y2="150.6947"/>
					</g>
				</g>
				<g id="_1_4_Ticks">

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="66.0534" y1="65.2841" x2="66.2454" y2="66.7399"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="64.8792" y1="65.454" x2="65.1083" y2="66.9049"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="63.7094" y1="65.6551" x2="63.977" y2="67.0992"/>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="59.0937" y1="66.7633" x2="59.511" y2="68.1713"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="84.8522" y1="153.7218" x2="84.4356" y2="152.3155"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="54.6196" y1="68.348" x2="55.1817" y2="69.7042"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="89.326" y1="152.1358" x2="88.7656" y2="150.7816"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="42.5225" y1="75.7607" x2="43.4764" y2="76.8777"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="101.4222" y1="144.7231" x2="100.4705" y2="143.6081"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="39.0797" y1="79.0277" x2="40.1449" y2="80.0393"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="104.8662" y1="141.4561" x2="103.8026" y2="140.4465"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="35.9969" y1="82.6365" x2="37.1621" y2="83.5308"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="107.9477" y1="137.8474" x2="106.7858" y2="136.955"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="29.2269" y1="95.1051" x2="30.6115" y2="95.5953"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="114.718" y1="125.3791" x2="113.3361" y2="124.8899"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.8785" y1="99.6561" x2="29.307" y2="99.9988"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.0654" y1="120.8291" x2="114.6405" y2="120.4854"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.0135" y1="104.3232" x2="28.4702" y2="104.5146"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.9305" y1="116.1619" x2="115.4776" y2="115.9696"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.3852" y1="118.5053" x2="28.8295" y2="118.2377"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.5595" y1="101.9789" x2="115.1183" y2="102.2464"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.4927" y1="123.1216" x2="29.9016" y2="122.7037"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.4516" y1="97.3645" x2="114.0462" y2="97.7795"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="30.0774" y1="127.5955" x2="31.4346" y2="127.0331"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="113.8666" y1="92.8897" x2="112.512" y2="93.4502"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="37.4901" y1="139.6927" x2="38.6071" y2="138.7378"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="106.4538" y1="80.793" x2="105.3388" y2="81.7441"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="40.7571" y1="143.1355" x2="41.7687" y2="142.0703"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="103.1868" y1="77.3503" x2="102.1772" y2="78.4126"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="44.3669" y1="146.218" x2="45.2612" y2="145.0531"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="99.5781" y1="74.2669" x2="98.6844" y2="75.4298"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="56.835" y1="152.9873" x2="57.3258" y2="151.6027"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="87.1096" y1="67.4976" x2="86.6194" y2="68.8791"/>
					</g>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="82.559" y1="66.1492" x2="82.2159" y2="67.5747"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="77.8925" y1="65.2841" x2="77.6998" y2="66.7379"/>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="60.2361" y1="66.4411" x2="60.6162" y2="67.8598"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="83.7098" y1="154.044" x2="83.3297" y2="152.626"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="55.7226" y1="67.9076" x2="56.2482" y2="69.2785"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="88.2233" y1="152.5772" x2="87.698" y2="151.2073"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="43.4354" y1="75.0011" x2="44.359" y2="76.1435"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="100.5102" y1="145.4828" x2="99.5878" y2="144.3433"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="39.9077" y1="78.1773" x2="40.9459" y2="79.2162"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="104.0369" y1="142.3075" x2="103" y2="141.2696"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="36.7315" y1="81.705" x2="37.8729" y2="82.6296"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="107.2134" y1="138.7798" x2="106.0737" y2="137.8571"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="29.638" y1="93.9911" x2="31.0089" y2="94.5183"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="114.3066" y1="126.4931" x2="112.9377" y2="125.9678"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.1708" y1="98.5049" x2="29.5902" y2="98.8867"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.7738" y1="121.9793" x2="114.3567" y2="121.5995"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.1843" y1="103.1486" x2="28.6352" y2="103.3791"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.7606" y1="117.3365" x2="115.3116" y2="117.1071"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.184" y1="117.3355" x2="28.6352" y2="117.1071"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.7606" y1="103.1486" x2="115.3116" y2="103.3781"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.1705" y1="121.9793" x2="29.5902" y2="121.5985"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.7738" y1="98.5069" x2="114.3567" y2="98.8857"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="29.637" y1="126.4931" x2="31.0089" y2="125.9668"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="114.3066" y1="93.992" x2="112.937" y2="94.5173"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="36.7311" y1="138.7798" x2="37.8729" y2="137.8552"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="107.2134" y1="81.705" x2="106.073" y2="82.6286"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="39.9067" y1="142.3075" x2="40.9466" y2="141.2686"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="104.0382" y1="78.1783" x2="103" y2="79.2152"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="43.4344" y1="145.4828" x2="44.359" y2="144.3413"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="100.5102" y1="75.0021" x2="99.5865" y2="76.1415"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="55.7209" y1="152.5772" x2="56.2482" y2="151.2053"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="88.2246" y1="67.9086" x2="87.6974" y2="69.2775"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="60.2354" y1="154.044" x2="60.6162" y2="152.625"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="83.7098" y1="66.4421" x2="83.3297" y2="67.8578"/>
					</g>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="79.0667" y1="65.455" x2="78.837" y2="66.9029"/>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="61.3869" y1="66.1492" x2="61.7297" y2="67.5766"/>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="56.8356" y1="67.4966" x2="57.3258" y2="68.8811"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="87.1096" y1="152.9873" x2="86.6201" y2="151.6047"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="44.3672" y1="74.2669" x2="45.2612" y2="75.4317"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="99.5781" y1="146.218" x2="98.6857" y2="145.0551"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="40.7581" y1="77.3483" x2="41.7693" y2="78.4146"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="103.1868" y1="143.1355" x2="102.1772" y2="142.0712"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="37.4911" y1="80.7921" x2="38.6078" y2="81.746"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="106.4538" y1="139.6927" x2="105.3388" y2="138.7398"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="30.078" y1="92.8887" x2="31.4346" y2="93.4511"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="113.8666" y1="127.5955" x2="112.512" y2="127.035"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="28.4937" y1="97.3635" x2="29.9016" y2="97.7804"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="115.4516" y1="123.1216" x2="114.0449" y2="122.7047"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.3855" y1="101.9789" x2="28.8295" y2="102.2464"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.5595" y1="118.5062" x2="115.1176" y2="118.2387"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.0145" y1="116.161" x2="28.4702" y2="115.9696"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.9305" y1="104.3242" x2="115.4776" y2="104.5156"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="27.8792" y1="120.8281" x2="29.307" y2="120.4854"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="116.0667" y1="99.6571" x2="114.6399" y2="99.9988"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="29.2269" y1="125.3791" x2="30.6115" y2="124.8889"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="114.718" y1="95.1051" x2="113.3354" y2="95.5953"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="35.9963" y1="137.8474" x2="37.1621" y2="136.953"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="107.9477" y1="82.6374" x2="106.7845" y2="83.5308"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="39.0791" y1="141.4571" x2="40.1449" y2="140.4455"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="104.8649" y1="79.0277" x2="103.802" y2="80.0373"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="42.5225" y1="144.7241" x2="43.4764" y2="143.6071"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="101.4222" y1="75.7607" x2="100.4705" y2="76.8758"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="54.6193" y1="152.1378" x2="55.1817" y2="150.7796"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="89.326" y1="68.348" x2="88.7643" y2="69.7032"/>
					</g>
					<g>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="59.0937" y1="153.7218" x2="59.511" y2="152.3126"/>

							<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="84.8509" y1="66.7643" x2="84.4349" y2="68.1703"/>
					</g>

						<line fill="none" stroke="#231F20" stroke-width="0.2622" stroke-miterlimit="10" x1="80.2365" y1="65.6551" x2="79.9689" y2="67.0972"/>
				</g>
			</g>
			<g id="Sec-Numerals">
				<g>
					<path fill="#231F20" d="M94.3386,70.5499l1.0684,0.6162l-0.1777,0.3057l-0.7539-0.4355l-0.3516,0.6094
						c0.0254,0.0117,0.0508,0.0234,0.0762,0.0381c0.2334,0.1348,0.3838,0.3164,0.4531,0.5459
						c0.0684,0.2285,0.0391,0.4521-0.0879,0.6719c-0.1309,0.2266-0.3105,0.3672-0.542,0.4238
						c-0.2305,0.0566-0.4639,0.0156-0.7012-0.1211c-0.1953-0.1123-0.3574-0.2695-0.4863-0.4697l0.2041-0.3545
						c0.1094,0.2129,0.2461,0.3662,0.4121,0.4609c0.1445,0.084,0.29,0.1123,0.4375,0.085c0.1465-0.0283,0.2559-0.1035,0.3262-0.2256
						c0.0742-0.1289,0.082-0.2656,0.0244-0.4131s-0.166-0.2666-0.3252-0.3584c-0.1367-0.0801-0.2373-0.1211-0.2988-0.127
						L94.3386,70.5499z"/>
				</g>
				<g>
					<path fill="#231F20" d="M51.052,149.3443l-0.021-0.0117c-0.1499-0.0869-0.2827-0.1221-0.397-0.1055
						c-0.1152,0.0176-0.2061,0.084-0.2744,0.2021c-0.062,0.1074-0.0737,0.2158-0.0361,0.3271
						c0.0381,0.1104,0.1191,0.2021,0.2432,0.2734c0.1255,0.0723,0.2866,0.1133,0.4849,0.124l-0.1899,0.3291
						c-0.1812-0.0107-0.3535-0.0645-0.519-0.1602c-0.2222-0.1279-0.3633-0.2861-0.4243-0.4775
						c-0.061-0.1895-0.0342-0.3848,0.0815-0.585c0.0703-0.1221,0.1548-0.21,0.2524-0.2646
						c0.0972-0.0547,0.2173-0.0811,0.3594-0.0781c-0.0728-0.0918-0.1157-0.1758-0.1289-0.2539
						c-0.0122-0.0801-0.0088-0.1641,0.0112-0.2539c0.019-0.0889,0.0537-0.1777,0.1025-0.2617
						c0.1216-0.2109,0.2925-0.3438,0.5117-0.4004c0.2192-0.0557,0.436-0.0234,0.6494,0.0996
						c0.1831,0.1055,0.3335,0.252,0.4526,0.4385l-0.2168,0.375c-0.1162-0.2178-0.2598-0.376-0.4312-0.4756
						c-0.1157-0.0664-0.2285-0.0859-0.3394-0.0576c-0.1104,0.0273-0.1982,0.0986-0.2642,0.2129
						c-0.0552,0.0957-0.0737,0.1953-0.0562,0.2998c0.0112,0.0605,0.0322,0.1123,0.0635,0.1553
						c0.0303,0.0439,0.1108,0.1133,0.2402,0.2109l0.0283,0.0215L51.052,149.3443z"/>
					<path fill="#231F20" d="M48.9851,149.4938l-1.0679-0.6172l0.1768-0.3066l0.7549,0.4365l0.3516-0.6094
						c-0.0259-0.0107-0.0518-0.0234-0.0767-0.0381c-0.2334-0.1348-0.3838-0.3164-0.4526-0.5459
						c-0.0684-0.2285-0.0396-0.4521,0.0874-0.6719c0.1309-0.2266,0.311-0.3672,0.542-0.4238
						c0.2305-0.0557,0.4644-0.0166,0.7012,0.1201c0.1953,0.1133,0.3574,0.2695,0.4863,0.4707l-0.2046,0.3545
						c-0.1084-0.2119-0.2456-0.3662-0.4111-0.4619c-0.1445-0.084-0.2905-0.1113-0.437-0.084
						c-0.147,0.0273-0.2563,0.1035-0.3271,0.2266c-0.0737,0.127-0.082,0.2646-0.0244,0.4121
						c0.0581,0.1465,0.166,0.2666,0.3257,0.3594c0.1367,0.0781,0.2368,0.1211,0.2988,0.126L48.9851,149.4938z"/>
				</g>
				<g>
					<path fill="#231F20" d="M110.9187,86.4601l0.1982,0.3438l-2.4062,1.3896l-0.1992-0.3447L110.9187,86.4601z"/>
					<path fill="#231F20" d="M111.821,87.9503c0.127,0.2207,0.1172,0.4707-0.0322,0.748c-0.1475,0.2773-0.3994,0.5195-0.7559,0.7246
						c-0.3662,0.2109-0.7041,0.3105-1.0156,0.2988c-0.3115-0.0127-0.5342-0.1328-0.667-0.3633
						c-0.1348-0.2324-0.1309-0.4854,0.0117-0.7559c0.1426-0.2715,0.3994-0.5127,0.7686-0.7266
						c0.3652-0.2109,0.7051-0.3096,1.0186-0.2959C111.4626,87.5929,111.6863,87.7169,111.821,87.9503z M111.4958,88.1427
						l-0.0107-0.0166c-0.0762-0.1328-0.2168-0.1904-0.4248-0.1738c-0.208,0.0156-0.4502,0.1045-0.7275,0.2656
						c-0.2852,0.1641-0.4873,0.3301-0.6045,0.5c-0.1191,0.1699-0.1396,0.3203-0.0635,0.4541
						c0.0771,0.1338,0.2188,0.1914,0.4258,0.1748c0.207-0.0156,0.4482-0.1055,0.7266-0.2656
						c0.2793-0.1611,0.4805-0.3262,0.6025-0.4961C111.5427,88.4152,111.5681,88.2687,111.4958,88.1427z"/>
				</g>
				<g>
					<path fill="#231F20" d="M34.0452,132.7984l0.3687-0.2129l-0.2051-0.3555l0.3457-0.1992l0.2051,0.3555l0.5845-0.3379
						l0.1978,0.3418l-0.585,0.3379l0.5688,0.9844l-2.3726,0.1387l-0.2227-0.3867l1.9277-0.1094l-0.2471-0.4277l-0.3682,0.2129
						L34.0452,132.7984z"/>
				</g>
				<g>
					<path fill="#231F20" d="M32.1599,132.149c-0.127-0.2207-0.1167-0.4697,0.0322-0.748c0.147-0.2773,0.3999-0.5186,0.7559-0.7246
						c0.3657-0.2109,0.7041-0.3105,1.0156-0.2979c0.3115,0.0117,0.5347,0.1328,0.6675,0.3633
						c0.1343,0.2324,0.1299,0.4844-0.0127,0.7559c-0.1426,0.2695-0.3989,0.5117-0.7681,0.7256
						c-0.3652,0.2109-0.7051,0.3096-1.0186,0.2959S32.2947,132.3824,32.1599,132.149z M32.4851,131.9566l0.0103,0.0176
						c0.0762,0.1318,0.2178,0.1895,0.4253,0.1738c0.208-0.0166,0.4502-0.1055,0.728-0.2656c0.2852-0.165,0.4868-0.332,0.604-0.501
						c0.1191-0.1689,0.1396-0.3213,0.063-0.4541s-0.2188-0.1914-0.4258-0.1738c-0.2061,0.0156-0.4478,0.1035-0.7261,0.2646
						c-0.2793,0.1611-0.4805,0.3271-0.6025,0.4961C32.4382,131.6832,32.4128,131.8316,32.4851,131.9566z"/>
				</g>
				<g>
					<path fill="#231F20" d="M110.0486,130.8004l-0.5293,0.916l-0.332-0.1914l0.8799-1.5234l0.0244,0.0137l0.0859,0.2441
						c0.1504,0.3877,0.2842,0.7051,0.4023,0.9512s0.2139,0.4189,0.291,0.5176c0.0771,0.0996,0.1631,0.1758,0.2617,0.2324
						c0.1348,0.0781,0.2666,0.1025,0.3926,0.0732c0.126-0.0303,0.2275-0.1084,0.3008-0.2354
						c0.0557-0.0967,0.0811-0.208,0.0791-0.335c-0.0039-0.126-0.0342-0.2568-0.0947-0.3916l0.4375,0.2529
						c0.0449,0.2764,0.0098,0.5127-0.1055,0.7119c-0.1211,0.21-0.291,0.3418-0.5098,0.3975s-0.4365,0.0205-0.6514-0.1035
						c-0.0967-0.0557-0.1904-0.1318-0.2812-0.2295c-0.0898-0.0977-0.1816-0.2305-0.2744-0.3984
						c-0.0928-0.1699-0.2041-0.4287-0.3311-0.7773L110.0486,130.8004z"/>
					<path fill="#231F20" d="M111.0378,133.9488c-0.127,0.2207-0.3477,0.3359-0.6631,0.3467
						c-0.3135,0.0107-0.6494-0.0869-1.0059-0.292c-0.3652-0.2109-0.6211-0.4551-0.7656-0.7305
						c-0.1455-0.2764-0.1523-0.5293-0.0195-0.7598c0.1338-0.2324,0.3555-0.3555,0.6611-0.3672s0.6426,0.0889,1.0127,0.3027
						c0.3652,0.2109,0.6211,0.4551,0.7656,0.7334C111.1687,133.4606,111.1726,133.7164,111.0378,133.9488z M110.7097,133.7633
						l0.0098-0.0176c0.0762-0.1309,0.0557-0.2832-0.0625-0.4541c-0.1182-0.1729-0.3164-0.3369-0.5938-0.498
						c-0.2852-0.165-0.5303-0.2559-0.7363-0.2725c-0.2061-0.0186-0.3477,0.0391-0.4238,0.1719
						c-0.0771,0.1328-0.0566,0.2852,0.0615,0.4561c0.1172,0.1709,0.3145,0.3359,0.5928,0.4971
						c0.2793,0.1602,0.5234,0.252,0.7305,0.2734C110.4968,133.941,110.6374,133.8883,110.7097,133.7633z"/>
				</g>
				<g>
					<path fill="#231F20" d="M31.8679,88.921l0.6162-1.0679l0.3057,0.1768l-0.4355,0.7549l0.6094,0.3516
						c0.0117-0.0259,0.0234-0.0518,0.0381-0.0767c0.1348-0.2334,0.3164-0.3838,0.5459-0.4526
						c0.2285-0.0684,0.4521-0.0396,0.6719,0.0874c0.2266,0.1309,0.3672,0.311,0.4238,0.542
						c0.0566,0.2305,0.0156,0.4644-0.1211,0.7012c-0.1123,0.1953-0.2695,0.3574-0.4697,0.4863l-0.3545-0.2046
						c0.2129-0.1084,0.3662-0.2456,0.4609-0.4111c0.084-0.1445,0.1123-0.2905,0.085-0.4375
						c-0.0283-0.1465-0.1035-0.2559-0.2256-0.3267c-0.1289-0.0737-0.2656-0.082-0.4131-0.0244s-0.2666,0.166-0.3584,0.3257
						c-0.0801,0.1367-0.1211,0.2368-0.127,0.2988L31.8679,88.921z"/>
					<path fill="#231F20" d="M33.1667,86.5992c0.127-0.2207,0.3477-0.3359,0.6631-0.3462c0.3135-0.0112,0.6494,0.0869,1.0059,0.2925
						c0.3652,0.2109,0.6211,0.4541,0.7656,0.7305c0.1455,0.2759,0.1523,0.5293,0.0195,0.7593
						c-0.1338,0.2329-0.3555,0.3555-0.6611,0.3672s-0.6426-0.0889-1.0127-0.3022c-0.3652-0.2109-0.6211-0.4556-0.7656-0.7339
						C33.0359,87.088,33.032,86.8326,33.1667,86.5992z M33.4949,86.7848l-0.0098,0.0176c-0.0762,0.1318-0.0557,0.2837,0.0625,0.4546
						c0.1182,0.1724,0.3164,0.3374,0.5938,0.498c0.2852,0.1646,0.5303,0.2559,0.7363,0.2729
						c0.2061,0.0181,0.3477-0.0391,0.4238-0.1724c0.0771-0.1333,0.0566-0.2856-0.0615-0.4561
						c-0.1172-0.1704-0.3145-0.3359-0.5928-0.4966c-0.2793-0.1611-0.5234-0.2524-0.7305-0.2734
						C33.7078,86.608,33.5671,86.6598,33.4949,86.7848z"/>
				</g>
				<g>
					<path fill="#231F20" d="M94.7038,147.024l-0.917,0.5283l-0.1924-0.332l1.5234-0.8789l0.0137,0.0244l-0.0469,0.2539
						c-0.0635,0.4111-0.1064,0.7529-0.127,1.0254c-0.0215,0.2725-0.0234,0.4697-0.0068,0.5938s0.0537,0.2334,0.1104,0.332
						c0.0781,0.1357,0.1797,0.2217,0.3037,0.2598c0.124,0.0371,0.251,0.0195,0.3779-0.0537c0.0967-0.0557,0.1748-0.1396,0.2363-0.25
						c0.0605-0.1113,0.0977-0.2393,0.1133-0.3867l0.2529,0.4375c-0.0986,0.2617-0.248,0.4492-0.4473,0.5645
						c-0.21,0.1211-0.4229,0.1504-0.6406,0.0889c-0.2168-0.0615-0.3877-0.2002-0.5127-0.416
						c-0.0547-0.0957-0.0977-0.209-0.1279-0.3389c-0.0293-0.1289-0.042-0.29-0.0381-0.4824
						c0.0039-0.1934,0.0371-0.4727,0.1016-0.8389L94.7038,147.024z"/>
					<path fill="#231F20" d="M94.5066,149.9039l-1.0684,0.6162l-0.1758-0.3057l0.7539-0.4365l-0.3516-0.6084
						c-0.0225,0.0156-0.0469,0.0322-0.0713,0.0469c-0.2334,0.1348-0.4658,0.1738-0.6982,0.1191
						c-0.2324-0.0557-0.4121-0.1924-0.5391-0.4121c-0.1309-0.2266-0.1621-0.4531-0.0957-0.6807s0.2188-0.4111,0.4551-0.5479
						c0.1953-0.1123,0.4121-0.1738,0.6504-0.1855l0.2051,0.3545c-0.2383-0.0127-0.4404,0.0293-0.6055,0.125
						c-0.1445,0.083-0.2422,0.1963-0.292,0.3369s-0.0381,0.2734,0.0322,0.3965c0.0742,0.127,0.1885,0.2031,0.3447,0.2266
						c0.1572,0.0234,0.3145-0.0098,0.4736-0.1016c0.1367-0.0801,0.2236-0.1445,0.2598-0.1963L94.5066,149.9039z"/>
				</g>
				<g>
					<path fill="#231F20" d="M47.9353,71.6647l1.0674-0.6167l0.1768,0.3062l-0.7549,0.4355l0.3516,0.6094
						c0.0225-0.0166,0.0469-0.0332,0.0713-0.0474c0.2344-0.1348,0.4668-0.1743,0.6992-0.1187
						c0.2324,0.0547,0.4121,0.1914,0.5391,0.4111c0.1309,0.2266,0.1621,0.4531,0.0957,0.6816
						c-0.0664,0.2275-0.2188,0.4102-0.4551,0.5469c-0.1953,0.1128-0.4121,0.1748-0.6504,0.186l-0.2051-0.3545
						c0.2383,0.0122,0.4395-0.0298,0.6055-0.1255c0.1445-0.0835,0.2422-0.1953,0.292-0.3364
						c0.0488-0.1411,0.0381-0.2734-0.0322-0.396c-0.0742-0.1279-0.1895-0.2036-0.3457-0.2275
						c-0.1562-0.0234-0.3145,0.0107-0.4736,0.1025c-0.1367,0.0791-0.2236,0.1445-0.2588,0.1958L47.9353,71.6647z"/>
					<path fill="#231F20" d="M49.699,70.6461l1.0684-0.6172l0.1768,0.3066l-0.7549,0.4355l0.3516,0.6089
						c0.0234-0.0161,0.0469-0.0327,0.0723-0.0474c0.2324-0.1348,0.4648-0.1738,0.6982-0.1187
						c0.2324,0.0552,0.4111,0.1919,0.5381,0.4116c0.1309,0.2266,0.1631,0.4531,0.0957,0.6812
						c-0.0664,0.228-0.2178,0.4106-0.4551,0.5474c-0.1953,0.1123-0.4121,0.1748-0.6504,0.1855l-0.2041-0.3545
						c0.2383,0.0127,0.4404-0.0298,0.6055-0.125c0.1445-0.084,0.2412-0.1958,0.292-0.3369
						c0.0488-0.1406,0.0381-0.2734-0.0332-0.3955c-0.0732-0.1279-0.1875-0.2041-0.3438-0.2275
						c-0.1572-0.0234-0.3145,0.0103-0.4746,0.1025c-0.1367,0.0791-0.2227,0.1445-0.2588,0.1953L49.699,70.6461z"/>
				</g>
			</g>
		</g>
    <linearGradient id="Center_hole_1_" gradientUnits="userSpaceOnUse" x1="73.4606" y1="493.2785" x2="70.4841" y2="488.1231" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
			<stop  offset="0.3022" style="stop-color:#FCFCFC"/>
			<stop  offset="0.5005" style="stop-color:#F4F4F4"/>
			<stop  offset="0.669" style="stop-color:#E5E5E5"/>
			<stop  offset="0.8207" style="stop-color:#CFCFCF"/>
			<stop  offset="0.9599" style="stop-color:#B4B4B4"/>
			<stop  offset="1" style="stop-color:#ABABAB"/>
		</linearGradient>
		<path id="Center_hole" fill="url(#Center_hole_1_)" stroke="#231F20" stroke-width="0.0709" stroke-miterlimit="10" d="
			M74.9483,110.2186c0.0005,1.6436-1.3314,2.9764-2.975,2.977s-2.9764-1.3314-2.977-2.975c-0.0005-1.6436,1.3314-2.9764,2.975-2.977
			c0.0002,0,0.0005,0,0.0007,0C73.6154,107.2433,74.948,108.5752,74.9483,110.2186z"/>
	</g>
	<g id="Date_window">
		<g id="Chamfer">
			<polygon fill="#E6E7E8" points="96.7735,107.4554
				95.9235,106.6064 105.2765,106.6064 104.4265,107.4554 			"/>
			<polygon fill="#D1D3D4" points="96.7735,112.9824
				95.9235,113.8334 95.9235,106.6064 96.7735,107.4554 			"/>
			<polygon fill="#FFFFFF" points="104.4255,112.9824
				105.2765,113.8334 95.9235,113.8334 96.7735,112.9824 			"/>
			<polygon fill="#FFFFFF" points="104.4255,107.4554
				105.2765,106.6064 105.2765,113.8334 104.4255,112.9824 			"/>
		</g>
	</g>
	<g id="Numeral">
		<g>
			<path fill="#231F20" d="M50.6882,75.2389h1.1572v8.085h-1.1572V75.2389z"/>
		</g>
		<g>
			<path fill="#231F20" d="M54.5994,75.2389h1.1572v8.085h-1.1572V75.2389z"/>
		</g>
		<g>
			<path fill="#231F20" d="M37.4187,88.775h1.1572v8.085h-1.1572V88.775z"/>
			<path fill="#231F20" d="M42.488,88.6715c0.7407,0,1.353,0.3887,1.8374,1.166c0.4839,0.7773,0.7261,1.7637,0.7261,2.96
				c0,1.2266-0.2422,2.2246-0.7261,2.9922c-0.4844,0.7676-1.1123,1.1514-1.8838,1.1514c-0.7832,0-1.4121-0.376-1.8867-1.1289
				c-0.4741-0.752-0.7114-1.749-0.7114-2.9912c0-1.2275,0.2446-2.2256,0.7349-2.9951
				C41.0681,89.0563,41.7048,88.6715,42.488,88.6715z M42.4997,89.7711h-0.0581c-0.4438,0-0.7954,0.2725-1.0562,0.8184
				c-0.2603,0.5459-0.3906,1.2861-0.3906,2.2197c0,0.957,0.1274,1.707,0.3818,2.251c0.2549,0.5439,0.606,0.8164,1.0532,0.8164
				c0.4478,0,0.8008-0.2725,1.0591-0.8164c0.2588-0.5439,0.3877-1.2822,0.3877-2.2168c0-0.9375-0.124-1.6836-0.373-2.2393
				S42.9202,89.7711,42.4997,89.7711z"/>
		</g>
		<g>
			<path fill="#231F20" d="M34.4333,114.232l-0.7119-0.8389c0.5981-0.3789,1.1211-0.8369,1.5684-1.375
				c0.4478-0.5381,0.7466-1.0908,0.897-1.6582c-0.3662,0.2285-0.7964,0.3418-1.2905,0.3418c-0.6172,0-1.1465-0.2295-1.5884-0.6885
				s-0.6626-1.0107-0.6626-1.6553c0-0.6709,0.2354-1.2402,0.7061-1.707s1.0454-0.7002,1.7246-0.7002
				c0.7637,0,1.3887,0.2754,1.875,0.8271c0.4858,0.5518,0.729,1.2598,0.729,2.124c0,0.9805-0.3047,1.9707-0.9141,2.9717
				C36.156,112.8746,35.3787,113.6608,34.4333,114.232z M36.4128,109.2086c0.0459-0.3086,0.0693-0.5088,0.0693-0.6016
				c0-0.4668-0.1304-0.8486-0.3906-1.1465c-0.2603-0.2969-0.5952-0.4453-1.0039-0.4453c-0.3745,0-0.6841,0.127-0.9292,0.3789
				c-0.2451,0.2529-0.3672,0.5703-0.3672,0.9521c0,0.3516,0.1328,0.6543,0.3989,0.9082c0.2666,0.2549,0.585,0.3828,0.9551,0.3828
				C35.5774,109.6373,35.9997,109.4938,36.4128,109.2086z"/>
		</g>
		<g>
			<path fill="#231F20" d="M39.8225,123.2897c0.3062,0,0.6006,0.0566,0.8838,0.1719s0.5342,0.2734,0.7524,0.4766
				c0.2178,0.2031,0.3901,0.4404,0.5166,0.7119c0.126,0.2715,0.1895,0.5605,0.1895,0.8672c0,0.6045-0.2261,1.1211-0.6777,1.5498
				c0.3828,0.2754,0.666,0.5742,0.8496,0.8955c0.1841,0.3213,0.2759,0.6885,0.2759,1.1025c0,0.3369-0.0747,0.6523-0.2241,0.9463
				c-0.1489,0.2949-0.3501,0.5557-0.6025,0.7812c-0.2529,0.2256-0.5474,0.4033-0.8843,0.5342
				c-0.3369,0.1299-0.6929,0.1953-1.0679,0.1953c-0.3901,0-0.7539-0.0654-1.0908-0.1953c-0.3369-0.1309-0.6313-0.3066-0.8838-0.5283
				s-0.4517-0.4824-0.5972-0.7812c-0.1455-0.2979-0.2183-0.6152-0.2183-0.9521c0-0.7197,0.2793-1.3135,0.8384-1.7803
				c0.1221-0.1074,0.2104-0.1719,0.2642-0.1953c-0.4517-0.4668-0.6777-0.9912-0.6777-1.5723c0-0.3066,0.0635-0.5957,0.1895-0.8672
				c0.1265-0.2715,0.2949-0.5068,0.5054-0.7061s0.4595-0.3574,0.7461-0.4766C39.1965,123.3492,39.5007,123.2897,39.8225,123.2897z
				 M39.8225,127.5953c-0.2065,0-0.4097,0.0342-0.6084,0.1025c-0.1992,0.0693-0.3735,0.165-0.5225,0.2871
				c-0.1494,0.123-0.27,0.2685-0.3618,0.4365c-0.0918,0.1689-0.1377,0.3525-0.1377,0.5508c0,0.1992,0.0439,0.3828,0.1318,0.5518
				c0.0879,0.168,0.2065,0.3154,0.356,0.4414c0.1494,0.127,0.3232,0.2246,0.5225,0.293c0.1987,0.0693,0.4092,0.1035,0.6313,0.1035
				c0.207,0,0.4077-0.0342,0.603-0.1035c0.1953-0.0684,0.3672-0.1641,0.5166-0.2871c0.1494-0.1221,0.27-0.2676,0.3618-0.4355
				c0.0918-0.1689,0.1377-0.3564,0.1377-0.5635c0-0.1982-0.0459-0.3818-0.1377-0.5508c-0.0918-0.168-0.2144-0.3135-0.3677-0.4365
				c-0.1533-0.1221-0.3271-0.2178-0.5225-0.2871c-0.1948-0.0684-0.3921-0.1025-0.5913-0.1025h-0.0111V127.5953z M40.6721,124.7819
				c-0.2222-0.2217-0.5054-0.333-0.8496-0.333c-0.1836,0-0.3501,0.0332-0.4995,0.0977c-0.1494,0.0654-0.2754,0.1514-0.3789,0.2588
				c-0.1035,0.1064-0.1821,0.2256-0.2354,0.3555c-0.0537,0.1299-0.0806,0.2646-0.0806,0.4023c0,0.1523,0.0308,0.2979,0.0918,0.4355
				c0.0615,0.1377,0.1436,0.2588,0.2471,0.3623s0.2275,0.1855,0.373,0.2461c0.1455,0.0615,0.3062,0.0928,0.4824,0.0928
				c0.1606,0,0.3115-0.0293,0.4536-0.0869c0.1411-0.0566,0.2676-0.1377,0.3789-0.2412c0.1108-0.1025,0.1968-0.2236,0.2583-0.3613
				c0.061-0.1377,0.0918-0.2871,0.0918-0.4473C41.0051,125.2867,40.8938,125.027,40.6721,124.7819z"/>
		</g>
		<g>
			<path fill="#231F20" d="M50.8591,137.0065h5.2314l-3.6582,8.1797l-1.0352-0.4365l2.9565-6.6377H50.859L50.8591,137.0065
				L50.8591,137.0065z"/>
		</g>
		<g>
			<path fill="#231F20" d="M89.4343,137.0065h3.5879v1.0303H90.487v2.043c0.0811-0.0078,0.1641-0.0117,0.249-0.0117
				c0.7832,0,1.4277,0.2383,1.9336,0.7148c0.5049,0.4766,0.7578,1.083,0.7578,1.8203c0,0.7598-0.25,1.3779-0.75,1.8545
				c-0.499,0.4766-1.1465,0.7148-1.9414,0.7148c-0.6553,0-1.292-0.1582-1.9092-0.4746v-1.1924
				c0.582,0.3789,1.1514,0.5674,1.707,0.5674c0.4863,0,0.8936-0.1416,1.2236-0.4258c0.3301-0.2832,0.4951-0.6309,0.4951-1.0439
				c0-0.4287-0.1797-0.7861-0.5381-1.0732c-0.3594-0.2881-0.8066-0.4316-1.3428-0.4316c-0.459,0-0.7715,0.0391-0.9375,0.1162
				v-4.2081H89.4343z"/>
		</g>
		<g>
			<path fill="#231F20" d="M106.1872,127.1129v1.2402h1.1943v1.1592h-1.1943v1.9629h-1.1484v-1.9629h-3.3066l3.0996-6.1768h1.2979
				l-2.5264,5.0176h1.4355v-1.2402L106.1872,127.1129L106.1872,127.1129z"/>
		</g>
		<g>
			<path fill="#231F20" d="M104.0945,95.4811h3.0781v1.1172h-5.1162v-0.0811l0.4863-0.5732
				c0.7598-0.9414,1.3643-1.7393,1.8145-2.3955c0.4492-0.6562,0.7422-1.1514,0.8789-1.4873
				c0.1377-0.3359,0.2061-0.667,0.2061-0.9951c0-0.4551-0.1299-0.8213-0.3877-1.0967c-0.2588-0.2764-0.6025-0.4141-1.0303-0.4141
				c-0.3242,0-0.6436,0.0957-0.958,0.2861c-0.3145,0.1914-0.5967,0.4609-0.8477,0.8076v-1.4697
				c0.6289-0.5127,1.2773-0.7695,1.9443-0.7695c0.7061,0,1.2881,0.2354,1.7451,0.7061s0.6855,1.0684,0.6855,1.7939
				c0,0.3242-0.0566,0.6709-0.1709,1.0391c-0.1133,0.3682-0.3154,0.793-0.6045,1.2734s-0.7812,1.1348-1.4746,1.9648
				L104.0945,95.4811z"/>
		</g>
		<g>
			<path fill="#231F20" d="M91.7497,75.2389h1.1572v8.085h-1.1572V75.2389z"/>
		</g>
	</g>
	<g id="S_Logo">
		<g>
			<path fill="#231F20" d="M57.9595,108.6091c-0.0176-0.0645-0.0332-0.1016-0.0547-0.1621c-0.07-0.1836-0.1973-0.4961-0.26-0.6445
				c-0.3015-0.7095-0.6465-1.3996-1.0332-2.0664c-0.4137-0.7204-0.8763-1.4114-1.3847-2.0684
				c-0.045-0.06-0.1309-0.1719-0.2129-0.2734c-0.041-0.0508-0.08-0.1-0.1133-0.1406c-0.0298-0.0376-0.0618-0.0735-0.0957-0.1075
				c-0.207-0.1956-0.4809-0.3046-0.7656-0.3047h-0.002c-0.1947,0.0005-0.3858,0.0516-0.5547,0.1485
				c-0.0675,0.04-0.1309,0.0865-0.1894,0.1387l-0.1016,0.0937l0.0078,0.01c-0.1152,0.1386-0.2988,0.3808-0.3613,0.4629
				c-0.5051,0.656-0.9658,1.345-1.3789,2.0625c-0.4119,0.7123-0.7766,1.4509-1.0918,2.2109
				c-0.0235,0.0566-0.0742,0.1777-0.1192,0.2852c-0.0234,0.0527-0.0449,0.1034-0.0625,0.1425
				c-0.0175,0.041-0.0253,0.0625-0.0351,0.084c-0.218,0.5752,0.0715,1.2182,0.6467,1.4363
				c0.0218,0.0083,0.0439,0.0159,0.0662,0.0227c0.0832,0.0252,0.169,0.0409,0.2558,0.0468
				c0.9607,0.1512,1.9318,0.2263,2.9043,0.2247c0.6446,0.0008,1.2888-0.0318,1.93-0.0977c0.1856-0.0176,0.7461-0.0859,1.1524-0.1523
				c0.3086-0.059,0.5746-0.2532,0.7246-0.5293c0.01-0.02,0.0195-0.0352,0.0234-0.0469l0.0078-0.0137l0,0l0.002-0.0039l0.0019-0.0039
				l0,0v-0.0039l0.002-0.002c0.0094-0.0178,0.0179-0.036,0.0254-0.0546c0.0624-0.1408,0.0943-0.2933,0.0937-0.4473
				C57.9865,108.7726,57.9773,108.69,57.9595,108.6091z"/>
			<path fill="#FFFFFF" d="M51.1333,109.8532c-0.0783-0.0038-0.1557-0.0176-0.2305-0.041l0,0
				c-0.4114-0.1259-0.6926-0.5053-0.6933-0.9355l0,0c0.0001-0.1189,0.0219-0.2367,0.0644-0.3477l0,0
				c0.0078-0.0195,0.0176-0.039,0.0352-0.08l0,0c0.0156-0.039,0.0371-0.09,0.0605-0.1445l0,0
				c0.045-0.1054,0.0977-0.2265,0.1211-0.2851l0,0c0.3126-0.7555,0.6747-1.4895,1.084-2.1973l0,0
				c0.4102-0.7117,0.8669-1.3954,1.3672-2.0469l0,0c0.07-0.0918,0.293-0.3828,0.3945-0.498l0,0
				c0.0141-0.0177,0.0298-0.034,0.0469-0.0488l0,0c0.05-0.0478,0.1058-0.0891,0.166-0.1231l0,0
				c0.1485-0.0871,0.3178-0.1323,0.49-0.1308l0,0c0.2496-0.0006,0.49,0.0945,0.6718,0.2656l0,0
				c0.0332,0.0332,0.0508,0.0566,0.086,0.0976l0,0c0.0332,0.0391,0.0722,0.0879,0.1133,0.1387l0,0
				c0.08,0.1016,0.166,0.2129,0.2128,0.2715l0,0c0.5032,0.6538,0.9625,1.3402,1.375,2.0547l0,0
				c0.3829,0.6629,0.7254,1.3484,1.0254,2.0527l0,0c0.0606,0.1465,0.1875,0.459,0.2559,0.6367l0,0
				c0.0234,0.0645,0.0371,0.0957,0.0508,0.1465l0,0c0.0155,0.0712,0.0233,0.1439,0.0234,0.2168l0,0
				c0.0004,0.1364-0.0276,0.2714-0.082,0.3965l0,0c-0.0117,0.0254-0.02,0.041-0.0254,0.0508l0,0v0.0019l-0.002,0.002l0,0v0.0019l0,0
				c-0.0039,0.0059-0.0117,0.0254-0.0293,0.0567l0,0c-0.1301,0.2416-0.3615,0.4121-0.6308,0.4648l0,0
				c-0.4,0.0664-0.9629,0.1328-1.1445,0.1523l0,0c-0.6367,0.0642-1.2762,0.0961-1.9161,0.0957l0,0
				c-0.968,0.0026-1.9346-0.0725-2.8906-0.2246L51.1333,109.8532z M50.6743,108.8767c0,0.2264,0.1472,0.4266,0.3633,0.4941l0,0
				c0.0426,0.0123,0.0866,0.0196,0.1309,0.0215h0.0136l0.0137,0.0019c0.9353,0.1491,1.881,0.2229,2.8281,0.2208l0,0
				c0.6236,0.0011,1.2468-0.0302,1.8672-0.0938l0,0c0.1719-0.0176,0.7344-0.0859,1.1172-0.1484l0,0
				c0.1323-0.0305,0.2444-0.1177,0.3067-0.2383l0,0l0.0136-0.0313l0,0l0.0039-0.0058l0,0c0.0036-0.0096,0.0082-0.0188,0.0137-0.0274
				l0,0v-0.0019l0.002-0.0039c0.028-0.0661,0.0426-0.1372,0.0429-0.209l0,0c-0.0001-0.0368-0.0041-0.0734-0.0117-0.1094l0,0v-0.0019
				l0,0l-0.0078-0.02l0,0c-0.0059-0.0156-0.0137-0.039-0.0254-0.0683l0,0c-0.0195-0.0547-0.0488-0.127-0.08-0.2051l0,0
				c-0.06-0.1524-0.1308-0.3242-0.17-0.416l0,0c-0.2912-0.6869-0.6252-1.3549-1-2l0,0c-0.4013-0.6972-0.849-1.3667-1.34-2.0039l0,0
				c-0.043-0.0547-0.125-0.16-0.2012-0.2559l0,0c-0.0723-0.0918-0.1485-0.1855-0.1621-0.1992l0,0
				c-0.0963-0.0888-0.2225-0.1382-0.3535-0.1386l0,0c-0.0905-0.0003-0.1794,0.0233-0.2579,0.0683l0,0
				c-0.0314,0.0185-0.0608,0.0401-0.0878,0.0645l0,0l-0.01,0.0117l0,0c-0.01,0.0117-0.0234,0.0273-0.041,0.0488l0,0
				c-0.0313,0.0391-0.0742,0.0918-0.1172,0.1465l0,0c-0.0859,0.1113-0.1758,0.2285-0.2168,0.2812l0,0
				c-0.4879,0.6354-0.9335,1.3022-1.334,1.9961l0,0c-0.3988,0.6893-0.7512,1.4045-1.0547,2.1407l0,0
				c-0.0508,0.123-0.1953,0.457-0.2129,0.5l0,0c-0.0221,0.058-0.0333,0.1196-0.0332,0.1817L50.6743,108.8767z"/>
			<path fill="#231F20" d="M50.6743,108.8767c0,0.2264,0.1472,0.4266,0.3633,0.4941l0,0c0.0426,0.0123,0.0866,0.0196,0.1309,0.0215
				h0.0136l0.0137,0.0019c0.9353,0.1491,1.881,0.2229,2.8281,0.2208l0,0c0.6236,0.0011,1.2468-0.0302,1.8672-0.0938l0,0
				c0.1719-0.0176,0.7344-0.0859,1.1172-0.1484l0,0c0.1323-0.0305,0.2444-0.1177,0.3067-0.2383l0,0l0.0136-0.0313l0,0l0.0039-0.0058
				l0,0c0.0036-0.0096,0.0082-0.0188,0.0137-0.0274l0,0v-0.0019l0.002-0.0039c0.028-0.0661,0.0426-0.1372,0.0429-0.209l0,0
				c-0.0001-0.0368-0.0041-0.0734-0.0117-0.1094l0,0v-0.0019l0,0l-0.0078-0.02l0,0c-0.0059-0.0156-0.0137-0.039-0.0254-0.0683l0,0
				c-0.0195-0.0547-0.0488-0.127-0.08-0.2051l0,0c-0.06-0.1524-0.1308-0.3242-0.17-0.416l0,0c-0.2912-0.6869-0.6252-1.3549-1-2l0,0
				c-0.4013-0.6972-0.849-1.3667-1.34-2.0039l0,0c-0.043-0.0547-0.125-0.16-0.2012-0.2559l0,0
				c-0.0723-0.0918-0.1485-0.1855-0.1621-0.1992l0,0c-0.0963-0.0888-0.2225-0.1382-0.3535-0.1386l0,0
				c-0.0905-0.0003-0.1794,0.0233-0.2579,0.0683l0,0c-0.0314,0.0185-0.0608,0.0401-0.0878,0.0645l0,0l-0.01,0.0117l0,0
				c-0.01,0.0117-0.0234,0.0273-0.041,0.0488l0,0c-0.0313,0.0391-0.0742,0.0918-0.1172,0.1465l0,0
				c-0.0859,0.1113-0.1758,0.2285-0.2168,0.2812l0,0c-0.4879,0.6354-0.9335,1.3022-1.334,1.9961l0,0
				c-0.3988,0.6893-0.7512,1.4045-1.0547,2.1407l0,0c-0.0508,0.123-0.1953,0.457-0.2129,0.5l0,0
				c-0.0221,0.058-0.0333,0.1196-0.0332,0.1817L50.6743,108.8767z"/>
			<polygon fill="#FFFFFF" points="55.9045,106.5484 54.5905,106.5484 54.5905,105.2144 53.5005,105.2144 53.5005,106.5484
				52.1645,106.5484 52.1645,107.6384 53.5005,107.6384 53.5005,108.9524 54.5905,108.9524 54.5905,107.6384 55.9045,107.6384
				"/>
		</g>
		<g>
			<path fill="#231F20" d="M48.6916,112.5368c0.8066,0.0586,1.0058,0.16,1.0058,0.7852c0,0.4512,0.02,0.8945-1.1816,0.8945
				c-0.6953,0-1.1563-0.0137-1.1563-0.9082h0.6993c0,0.2832,0.1015,0.3125,0.457,0.3125c0.3418,0,0.4551-0.0215,0.4551-0.2519
				c0-0.2364-0.041-0.2325-0.3828-0.2539l-0.16-0.0118c-0.6719-0.0468-1.0644-0.0429-1.0644-0.8242s0.4394-0.834,1.1523-0.834
				c0.5977,0,1.1055,0.0117,1.1055,0.7657v0.1113h-0.6973c0-0.2793-0.1172-0.2793-0.4082-0.2793
				c-0.3926,0-0.4258,0.08-0.4258,0.2324c0,0.2188,0.1055,0.2266,0.2989,0.24L48.6916,112.5368z"/>
			<path fill="#231F20" d="M53.2915,111.4685h0.7305l-0.6035,2.7265h-1.0508l-0.3711-1.709h-0.0293l-0.3965,1.709h-1.0391
				l-0.59-2.7265H50.68l0.3926,2.1015h0.0254l0.5136-2.1015h0.7559l0.4883,2.1015h0.0254L53.2915,111.4685z"/>
			<path fill="#231F20" d="M55.0884,114.195h-0.7266v-2.7265h0.7266V114.195z"/>
			<path fill="#231F20" d="M56.9265,112.5368c0.8066,0.0586,1.0078,0.16,1.0078,0.7852c0,0.4512,0.0176,0.8945-1.1836,0.8945
				c-0.6934,0-1.1563-0.0137-1.1563-0.9082h0.6993c0,0.2832,0.1015,0.3125,0.457,0.3125c0.3418,0,0.4551-0.0215,0.4551-0.2519
				c0-0.2364-0.0391-0.2325-0.3809-0.2539l-0.16-0.0118c-0.6739-0.0468-1.0664-0.0429-1.0664-0.8242s0.4394-0.834,1.1523-0.834
				c0.5977,0,1.1055,0.0117,1.1055,0.7657v0.1113H57.159c0-0.2793-0.1172-0.2793-0.4082-0.2793c-0.3926,0-0.4258,0.08-0.4258,0.2324
				c0,0.2188,0.1055,0.2266,0.2988,0.24L56.9265,112.5368z"/>
			<path fill="#231F20" d="M59.6765,112.5368c0.8066,0.0586,1.0058,0.16,1.0058,0.7852c0,0.4512,0.02,0.8945-1.1816,0.8945
				c-0.6934,0-1.1563-0.0137-1.1563-0.9082h0.6993c0,0.2832,0.1015,0.3125,0.457,0.3125c0.3418,0,0.4551-0.0215,0.4551-0.2519
				c0-0.2364-0.041-0.2325-0.3828-0.2539l-0.1582-0.0118c-0.6739-0.0468-1.0664-0.0429-1.0664-0.8242s0.4394-0.834,1.1523-0.834
				c0.5977,0,1.1055,0.0117,1.1055,0.7657v0.1113h-0.6973c0-0.2793-0.1172-0.2793-0.4082-0.2793
				c-0.3926,0-0.4258,0.08-0.4258,0.2324c0,0.2188,0.1055,0.2266,0.2988,0.24L59.6765,112.5368z"/>
			<path fill="#231F20" d="M47.6623,117.4646v-2.6661h1.5c0.3352-0.0391,0.6727,0.051,0.9437,0.252
				c0.198,0.2804,0.2863,0.6237,0.248,0.9648c0.0395,0.3993-0.0372,0.8014-0.2207,1.1582
				c-0.2318,0.2273-0.5556,0.3347-0.8773,0.2911H47.6623z M48.0275,117.2107h1.0567c0.2655,0.0375,0.535-0.0313,0.75-0.1915
				c0.1454-0.2594,0.2049-0.5582,0.17-0.8535c0.0331-0.3142-0.0174-0.6316-0.1465-0.92c-0.098-0.1289-0.33-0.1933-0.7-0.1933
				h-1.1302V117.2107z"/>
			<path fill="#231F20" d="M51.27,115.0524v0.9082h1.6446v0.2539H51.27v0.9961h1.7165v0.2539h-2.084v-2.6661h2.084v0.254H51.27z"/>
			<path fill="#231F20" d="M54.0165,114.7985v2.3868h1.668v0.2793h-2.0336v-2.6661H54.0165z"/>
			<path fill="#231F20" d="M56.8482,115.0778v2.3868h-0.3653v-2.3868h-1.0586v-0.2793h2.4707v0.2793H56.8482z"/>
			<path fill="#231F20" d="M60.0181,116.9001h-1.6406l-0.25,0.5645h-0.3868l1.1875-2.6661h0.5137l1.2109,2.6661H60.27
				L60.0181,116.9001z M59.9107,116.6735l-0.7188-1.6289l-0.7109,1.6289H59.9107z"/>
		</g>
	</g>
	<g id="Item_Number">
		<g>
			<path fill="#231F20" d="M86.3132,110.2945h1v0.3916h-1V110.2945z"/>
		</g>
		<g>
			<path fill="#231F20" d="M88.49,111.0133h1.0684v0.3877H87.783v-0.0283l0.1689-0.1982c0.2637-0.3271,0.4736-0.6035,0.6289-0.832
				c0.1562-0.2275,0.2578-0.3994,0.3057-0.5156s0.0713-0.2314,0.0713-0.3457c0-0.1572-0.0449-0.2842-0.1348-0.3799
				s-0.209-0.1436-0.3574-0.1436c-0.1123,0-0.2227,0.0332-0.332,0.0996c-0.1094,0.0654-0.207,0.1592-0.2939,0.2793v-0.5098
				c0.2178-0.1777,0.4424-0.2666,0.6748-0.2666c0.2441,0,0.4463,0.0811,0.6045,0.2451c0.1592,0.1631,0.2383,0.3701,0.2383,0.6221
				c0,0.1123-0.0195,0.2324-0.0596,0.3604c-0.0391,0.1279-0.1094,0.2754-0.209,0.4424c-0.1006,0.166-0.2715,0.3936-0.5117,0.6816
				L88.49,111.0133z"/>
			<path fill="#231F20" d="M90.5466,111.0133h1.0674v0.3877h-1.7744v-0.0283l0.168-0.1982c0.2637-0.3271,0.4736-0.6035,0.6299-0.832
				c0.1562-0.2275,0.2578-0.3994,0.3047-0.5156c0.0479-0.1162,0.0713-0.2314,0.0713-0.3457c0-0.1572-0.0449-0.2842-0.1338-0.3799
				c-0.0898-0.0957-0.209-0.1436-0.3574-0.1436c-0.1123,0-0.2236,0.0332-0.333,0.0996c-0.1084,0.0654-0.207,0.1592-0.2939,0.2793
				v-0.5098c0.2188-0.1777,0.4434-0.2666,0.6748-0.2666c0.2451,0,0.4473,0.0811,0.6055,0.2451
				c0.1582,0.1631,0.2383,0.3701,0.2383,0.6221c0,0.1123-0.0205,0.2324-0.0596,0.3604s-0.1094,0.2754-0.21,0.4424
				c-0.1006,0.166-0.2705,0.3936-0.5117,0.6816L90.5466,111.0133z"/>
		</g>
		<path fill="#231F20" d="M85.1227,110.821h-1.7331l-0.2637,0.5968h-0.4082l1.2539-2.8166h0.541l1.2781,2.8166h-0.4042
			L85.1227,110.821z M85.0087,110.5535l-0.76-1.7189l-0.7494,1.7189H85.0087z"/>
	</g>
	<g id="L-S.dial">
		<path id="L-Bkgd" fill="#FFFFFF" d="M85.024,131.4636c-0.0004,7.2-5.8376,13.0364-13.0376,13.036
			c-7.2-0.0004-13.0364-5.8376-13.036-13.0376c0.0004-7.1998,5.8371-13.0361,13.0369-13.036
			c7.1986-0.0013,13.0354,5.8333,13.0367,13.0319C85.024,131.4598,85.024,131.4617,85.024,131.4636z"/>

			<linearGradient id="L-Chamfer_1_" gradientUnits="userSpaceOnUse" x1="78.2823" y1="522.8518" x2="65.6873" y2="501.0366" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
			<stop  offset="0" style="stop-color:#F1F2F2"/>
			<stop  offset="0.3204" style="stop-color:#EEEFEF"/>
			<stop  offset="0.5306" style="stop-color:#E6E7E7"/>
			<stop  offset="0.7092" style="stop-color:#D7D8D8"/>
			<stop  offset="0.8691" style="stop-color:#C2C3C3"/>
			<stop  offset="1" style="stop-color:#ABABAB"/>
		</linearGradient>
		<path id="L-Chamfer" fill="url(#L-Chamfer_1_)" stroke="#D1D3D4" stroke-width="0.0161" stroke-miterlimit="10" d="
			M84.5788,131.4616c-0.0013,6.9543-5.64,12.5908-12.5943,12.5895c-6.9543-0.0013-12.5908-5.64-12.5895-12.5943
			c0.0013-6.9535,5.6388-12.5897,12.5923-12.5895C78.9418,118.869,84.5787,124.5071,84.5788,131.4616z M71.9873,118.4973
			c-7.1603-0.0016-12.9661,5.8016-12.9677,12.9619c-0.0016,7.1603,5.8016,12.9661,12.9619,12.9677s12.9661-5.8016,12.9677-12.9619
			c0-0.0011,0-0.0023,0-0.0034C84.9485,124.3029,79.1461,118.4994,71.9873,118.4973z"/>
		<g id="L-S.dial-2">
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="68.5074" y1="142.1666" x2="68.2028" y2="143.1059"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="69.6459" y1="142.4722" x2="69.4408" y2="143.4388"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M70.8091,142.6558l-0.1028,0.9832v0.001
					c-0.425-0.0442-0.8475-0.1107-1.2655-0.1992c-0.4188-0.0889-0.8326-0.1993-1.24-0.331
					c-0.4064-0.1317-0.8055-0.2849-1.1957-0.4589l0.0006-0.0039l0.4017-0.9022"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="75.7698" y1="119.8174" x2="75.4645" y2="120.7555"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="74.5317" y1="119.4844" x2="74.326" y2="120.4499"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M73.1629,120.2664l0.1034-0.9831l0,0
					c0.4251,0.0441,0.8475,0.1109,1.2654,0.2c0.4184,0.0876,0.8317,0.1981,1.2381,0.331c0.4069,0.1315,0.8065,0.2847,1.197,0.4588
					v0.0029l-0.4022,0.9022"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="63.6209" y1="138.9933" x2="62.8867" y2="139.6544"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="64.4548" y1="139.8262" x2="63.7928" y2="140.5614"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M65.3706,140.5683l-0.5813,0.8
					l-0.0006,0.001c-0.6921-0.5036-1.3296-1.0782-1.902-1.7145c-0.2866-0.3172-0.5558-0.6497-0.8065-0.996h0.0006l0.7987-0.5809"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="81.0853" y1="123.2687" x2="80.351" y2="123.9297"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="80.1792" y1="122.3617" x2="79.5205" y2="123.0959"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M78.6033,122.3539l0.58-0.7977v-0.002
					c0.3456,0.2529,0.6776,0.5221,0.9959,0.8075c0.3105,0.2812,0.6066,0.5767,0.8885,0.8865
					c0.2925,0.3237,0.5676,0.6627,0.8241,1.0155l-0.002,0.001l-0.7954,0.58"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="69.6472" y1="120.4509" x2="69.4408" y2="119.4844"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="68.5074" y1="120.7565" x2="68.2041" y2="119.8174"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M67.408,121.1783l-0.4023-0.9022
					l-0.0006-0.0029c0.3907-0.1737,0.7903-0.3269,1.197-0.4588c0.8141-0.2645,1.654-0.4418,2.5055-0.5292l0.1015,0.9821"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="74.5317" y1="143.4388" x2="74.3267" y2="142.4722"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="75.7698" y1="143.1078" x2="75.4645" y2="142.1685"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M76.5646,141.7467l0.4022,0.9
					l0.0014,0.0039c-0.3907,0.1738-0.7903,0.327-1.1971,0.4589c-0.4067,0.1317-0.82,0.2421-1.2381,0.331
					c-0.4141,0.088-0.8326,0.1542-1.2536,0.1982h-0.0129l-0.1021-0.9822"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="64.4548" y1="123.0969" x2="63.7934" y2="122.3617"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="63.6216" y1="123.9297" x2="62.8873" y2="123.2687"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M62.8795,124.8456l-0.7987-0.5809h-0.0006
					c0.2515-0.3458,0.5209-0.6783,0.8071-0.996c0.2806-0.3104,0.5761-0.6066,0.8866-0.8885c0.3232-0.293,0.6622-0.5681,1.0154-0.824
					h0.0013l0.58,0.7987"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="80.1792" y1="140.5614" x2="79.5205" y2="139.8272"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="81.0853" y1="139.6544" x2="80.351" y2="138.9943"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M81.0944,138.0785l0.7974,0.58l0,0
					c-0.2507,0.3463-0.5199,0.6788-0.8065,0.996c-0.2857,0.3182-0.5882,0.6209-0.9061,0.907
					c-0.3178,0.2862-0.6502,0.5557-0.9959,0.8075v-0.001l-0.58-0.7987"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="61.2815" y1="127.9837" x2="60.3422" y2="127.6781"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="60.9756" y1="129.1212" x2="60.0089" y2="128.9152"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M60.7914,130.2851l-0.9816-0.1025h-0.002
					c0.0442-0.4256,0.1107-0.8487,0.1992-1.2674c0.0893-0.4181,0.1999-0.8313,0.3313-1.2381
					c0.1318-0.4066,0.2851-0.8058,0.4595-1.196l0.0033,0.0009l0.9022,0.4013"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="83.6317" y1="135.245" x2="82.6924" y2="134.9403"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="83.963" y1="134.0079" x2="82.999" y2="133.8029"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M83.1825,132.639l0.98,0.1025h0.0026
					c-0.0442,0.4254-0.111,0.8481-0.2,1.2664c-0.0874,0.4185-0.198,0.8318-0.3313,1.238c-0.1318,0.407-0.2853,0.8066-0.46,1.1971
					l-0.0033-0.001l-0.9008-0.4013"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="60.9756" y1="133.8029" x2="60.0089" y2="134.0069"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="61.2815" y1="134.9403" x2="60.3409" y2="135.245"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M61.7033,136.0407l-0.9022,0.4013
					l-0.0033,0.001c-0.1745-0.3905-0.3279-0.7901-0.4595-1.1971c-0.1318-0.4066-0.2424-0.8199-0.3313-1.238
					c-0.0878-0.4141-0.1537-0.8326-0.1972-1.2537v-0.0127l0.9816-0.1025"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="83.963" y1="128.9152" x2="82.999" y2="129.1212"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="83.6317" y1="127.6781" x2="82.6924" y2="127.9828"/>
				<path fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" d="M82.27,126.8824l0.9008-0.4l0.0033-0.0009
					c0.1747,0.3901,0.3282,0.7894,0.46,1.196c0.1318,0.4067,0.2424,0.8199,0.3313,1.2381c0.088,0.4141,0.1538,0.8326,0.1972,1.2537
					v0.0137l-0.98,0.1025"/>
			</g>
			<g id="Thick_60_">

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="71.9866" y1="120.2058" x2="71.9866" y2="119.2179"/>

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="71.9866" y1="143.7064" x2="71.9866" y2="142.7182"/>

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="62.2384" y1="125.8337" x2="61.383" y2="125.3397"/>

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="82.5902" y1="137.5834" x2="81.7336" y2="137.0894"/>

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="62.2384" y1="137.0894" x2="61.383" y2="137.5834"/>

					<line fill="none" stroke="#231F20" stroke-width="0.4937" stroke-miterlimit="10" x1="82.5902" y1="125.3397" x2="81.7336" y2="125.8327"/>
			</g>
			<g id="Thin_60_">

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="66.3587" y1="121.7133" x2="65.8646" y2="120.858"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="78.1086" y1="142.066" x2="77.6152" y2="141.2107"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="60.7295" y1="131.4626" x2="59.7427" y2="131.4626"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="84.2293" y1="131.4626" x2="83.2444" y2="131.4626"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="66.3587" y1="141.2097" x2="65.8646" y2="142.066"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1234" stroke-miterlimit="10" x1="78.1086" y1="120.858" x2="77.6152" y2="121.7133"/>
			</g>
			<g>
				<path fill="#231F20" d="M71.1946,121.3502l0.04-0.0283l0.2432,0.3057c-0.2144,0.1377-0.3921,0.2891-0.5332,0.4521
					c-0.1411,0.1641-0.25,0.3564-0.3262,0.5771c0.1484-0.0762,0.2964-0.1143,0.4438-0.1143c0.2207,0,0.4067,0.0781,0.5576,0.2354
					c0.1514,0.1562,0.2271,0.3486,0.2271,0.5762c0,0.2334-0.0825,0.4326-0.2471,0.5957s-0.3647,0.2451-0.6001,0.2451
					c-0.2637,0-0.4766-0.0928-0.6392-0.2783s-0.2441-0.4277-0.2441-0.7275c0-0.2246,0.042-0.4482,0.1255-0.6719
					c0.0835-0.2227,0.2041-0.4307,0.3613-0.626C70.7605,121.6969,70.9578,121.5162,71.1946,121.3502z M70.532,123.0729
					c-0.0107,0.0625-0.0161,0.1328-0.0161,0.2109c0,0.1572,0.0459,0.2871,0.1377,0.3887c0.0918,0.1025,0.209,0.1533,0.3521,0.1533
					c0.1289,0,0.2349-0.0439,0.3184-0.1309s0.1255-0.1963,0.1255-0.3291c0-0.1348-0.0444-0.2441-0.1333-0.3281
					c-0.0894-0.084-0.2065-0.126-0.3525-0.126c-0.0747,0-0.1426,0.0117-0.2036,0.0342
					C70.699,122.9694,70.6233,123.0113,70.532,123.0729z"/>
				<path fill="#231F20" d="M73.0315,121.3219c0.2568,0,0.4692,0.1348,0.6372,0.4053c0.168,0.2695,0.252,0.6113,0.252,1.0264
					c0,0.4258-0.084,0.7715-0.252,1.0381c-0.168,0.2656-0.3857,0.3994-0.6533,0.3994c-0.272,0-0.4897-0.1309-0.6543-0.3916
					s-0.2471-0.6074-0.2471-1.0381c0-0.4258,0.085-0.7715,0.2549-1.0391C72.5388,121.4557,72.7595,121.3219,73.0315,121.3219z
					 M73.0354,121.7037h-0.02c-0.1538,0-0.2759,0.0947-0.3662,0.2842s-0.1357,0.4453-0.1357,0.7695
					c0,0.332,0.0444,0.5928,0.1323,0.7812c0.0884,0.1885,0.2104,0.2832,0.3657,0.2832s0.2773-0.0947,0.3672-0.2832
					s0.1343-0.4453,0.1343-0.7695c0-0.3252-0.043-0.584-0.1294-0.7764S73.1814,121.7037,73.0354,121.7037z"/>
			</g>
			<g>
				<path fill="#231F20" d="M77.427,136.5211h1.0674v0.3877H76.72v-0.0283l0.1685-0.1982c0.2637-0.3271,0.4736-0.6035,0.6294-0.8311
					s0.2578-0.3994,0.3052-0.5166c0.0474-0.1162,0.0713-0.2314,0.0713-0.3447c0-0.1582-0.0449-0.2852-0.1348-0.3809
					c-0.0894-0.0957-0.2085-0.1436-0.3569-0.1436c-0.1128,0-0.2231,0.0332-0.3325,0.0996c-0.1089,0.0664-0.207,0.1602-0.2939,0.2803
					v-0.5098c0.2183-0.1777,0.4429-0.2676,0.6743-0.2676c0.2451,0,0.4468,0.082,0.6055,0.2451
					c0.1582,0.1631,0.2378,0.3711,0.2378,0.6221c0,0.1133-0.02,0.2334-0.0591,0.3613c-0.0396,0.127-0.1094,0.2744-0.21,0.4414
					c-0.1001,0.166-0.271,0.3936-0.5117,0.6816L77.427,136.5211z"/>
				<path fill="#231F20" d="M79.6789,134.068c0.2568,0,0.4692,0.1348,0.6372,0.4053c0.168,0.2695,0.252,0.6113,0.252,1.0264
					c0,0.4258-0.084,0.7715-0.252,1.0381c-0.168,0.2656-0.3857,0.3994-0.6533,0.3994c-0.272,0-0.4897-0.1309-0.6543-0.3916
					s-0.2471-0.6074-0.2471-1.0381c0-0.4258,0.085-0.7715,0.2549-1.0391C79.1863,134.2018,79.407,134.068,79.6789,134.068z
					 M79.6829,134.4498h-0.02c-0.1538,0-0.2759,0.0947-0.3662,0.2842s-0.1357,0.4453-0.1357,0.7695
					c0,0.332,0.0444,0.5928,0.1323,0.7812c0.0884,0.1885,0.2104,0.2832,0.3657,0.2832s0.2773-0.0947,0.3672-0.2832
					s0.1343-0.4453,0.1343-0.7695c0-0.3252-0.043-0.584-0.1294-0.7764S79.8288,134.4498,79.6829,134.4498z"/>
			</g>
			<g>
				<path fill="#231F20" d="M64.9944,135.4156v0.4297h0.4141v0.4023h-0.4141v0.6816H64.596v-0.6816h-1.147l1.0752-2.1426h0.4502
					l-0.8765,1.7402h0.498v-0.4297L64.9944,135.4156L64.9944,135.4156z"/>
			</g>
			<g>
				<path fill="#231F20" d="M66.512,134.0963c0.2568,0,0.4692,0.1348,0.6372,0.4053c0.168,0.2695,0.252,0.6113,0.252,1.0264
					c0,0.4258-0.084,0.7715-0.252,1.0381c-0.168,0.2656-0.3857,0.3994-0.6533,0.3994c-0.272,0-0.4897-0.1309-0.6543-0.3916
					s-0.2471-0.6074-0.2471-1.0381c0-0.4258,0.085-0.7715,0.2549-1.0391C66.0193,134.2301,66.24,134.0963,66.512,134.0963z
					 M66.5159,134.4781h-0.02c-0.1538,0-0.2759,0.0947-0.3662,0.2842s-0.1357,0.4453-0.1357,0.7695
					c0,0.332,0.0444,0.5928,0.1323,0.7812c0.0884,0.1885,0.2104,0.2832,0.3657,0.2832s0.2773-0.0947,0.3672-0.2832
					s0.1343-0.4453,0.1343-0.7695c0-0.3252-0.043-0.584-0.1294-0.7764S66.6619,134.4781,66.5159,134.4781z"/>
			</g>

				<linearGradient id="SVGID_14_A-22" gradientUnits="userSpaceOnUse" x1="72.6234" y1="513.0474" x2="71.3479" y2="510.8383" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
				<stop  offset="0" style="stop-color:#FFFFFF"/>
				<stop  offset="0.3022" style="stop-color:#FCFCFC"/>
				<stop  offset="0.5005" style="stop-color:#F4F4F4"/>
				<stop  offset="0.669" style="stop-color:#E5E5E5"/>
				<stop  offset="0.8207" style="stop-color:#CFCFCF"/>
				<stop  offset="0.9599" style="stop-color:#B4B4B4"/>
				<stop  offset="1" style="stop-color:#ABABAB"/>
			</linearGradient>
			<path fill="url(#SVGID_14_A-22)" stroke="#231F20" stroke-width="0.0588" stroke-miterlimit="10" d="M73.2611,131.4624
				c-0.0005,0.7043-0.5718,1.2748-1.2761,1.2743c-0.7043-0.0005-1.2748-0.5718-1.2743-1.2761
				c0.0005-0.7035,0.5705-1.2737,1.274-1.2743C72.6894,130.1866,73.2607,130.7577,73.2611,131.4624z"/>
		</g>
	</g>
	<g id="U-S.dial">
		<path id="U-Bkgd" fill="#FFFFFF" d="M88.2839,88.95c-0.0002,9.0004-7.2966,16.2964-16.297,16.2962s-16.2964-7.2966-16.2962-16.297
			c0.0002-8.9999,7.2959-16.2958,16.2958-16.2962c9.0003-0.0005,16.2968,7.2951,16.2974,16.2954
			C88.2839,88.9489,88.2839,88.9495,88.2839,88.95z"/>

			<linearGradient id="U-Chamfer_1_" gradientUnits="userSpaceOnUse" x1="80.1369" y1="483.5465" x2="63.8375" y2="455.3152" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
			<stop  offset="0" style="stop-color:#F1F2F2"/>
			<stop  offset="0.3204" style="stop-color:#EEEFEF"/>
			<stop  offset="0.5306" style="stop-color:#E6E7E7"/>
			<stop  offset="0.7092" style="stop-color:#D7D8D8"/>
			<stop  offset="0.8691" style="stop-color:#C2C3C3"/>
			<stop  offset="1" style="stop-color:#ABABAB"/>
		</linearGradient>
		<path id="U-Chamfer" fill="url(#U-Chamfer_1_)" stroke="#D1D3D4" stroke-width="0.0162" stroke-miterlimit="10" d="M88.2839,88.95
			c-0.0002,9.0004-7.2966,16.2964-16.297,16.2962s-16.2964-7.2966-16.2962-16.297c0.0002-8.9999,7.2959-16.2958,16.2958-16.2962
			C80.9872,72.653,88.2838,79.9493,88.2839,88.95z M71.9865,73.0231c-8.7957,0.0001-15.9259,7.1305-15.9258,15.9262
			s7.1305,15.9259,15.9262,15.9258c8.7952-0.0001,15.9253-7.1298,15.9258-15.9251C87.9126,80.1542,80.7824,73.0237,71.9865,73.0231z
			"/>
		<g id="U-S.dial-2">

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="63.7147" y1="77.5633" x2="62.9889" y2="76.5645"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="80.9857" y1="101.3347" x2="80.2593" y2="100.3368"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="57.9897" y1="90.4206" x2="56.7615" y2="90.5494"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="87.2118" y1="87.3487" x2="85.9848" y2="87.4776"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="66.2617" y1="101.8062" x2="65.7599" y2="102.934"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="78.2121" y1="74.9642" x2="77.7109" y2="76.0909"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="66.2617" y1="76.0919" x2="65.7599" y2="74.9642"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="78.214" y1="102.934" x2="77.7109" y2="101.8072"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="57.9897" y1="87.4776" x2="56.7615" y2="87.3487"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="87.2118" y1="90.5494" x2="85.9848" y2="90.4206"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="63.7147" y1="100.3348" x2="62.9889" y2="101.3347"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="80.985" y1="76.5645" x2="80.2593" y2="77.5633"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M60.6104,99.1924l0.9178-0.826
				c0,0,0.6757,0.7128,1.0408,1.0418c1.097,0.9894,2.343,1.8,3.6921,2.4019c0.4487,0.2005,0.9078,0.3769,1.3754,0.5283
				c0.4641,0.15,1.4235,0.3769,1.4235,0.3769l-0.2557,1.2078"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M83.3635,78.7047l-0.9171,0.826
				l-0.0215-0.0224c-0.3226-0.3564-0.6631-0.6963-1.02-1.0184c-0.7319-0.657-1.5295-1.2371-2.38-1.7311
				c-0.4253-0.2463-0.8633-0.47-1.3122-0.67c-0.8978-0.4018-1.8359-0.7065-2.7984-0.9091l0.2546-1.2048"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M60.6104,78.7057l0.9178,0.826
				c0.6584-0.7304,1.3912-1.3901,2.1865-1.9684c1.1937-0.87,2.5173-1.5462,3.9218-2.0035c0.4677-0.1509,0.9428-0.2778,1.4235-0.38
				l-0.2557-1.2039"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M83.3642,99.1934l-0.9178-0.827
				c-1.3191,1.4672-2.9321,2.6405-4.7342,3.4437c-0.4486,0.2002-0.9075,0.3766-1.3748,0.5283
				c-0.4648,0.15-1.4236,0.3778-1.4236,0.3778l0.2559,1.2069"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M57.4273,93.6788l1.175-0.3808
				c0,0-0.2825-0.9383-0.3847-1.4216c-0.1008-0.4761-0.1769-0.9572-0.2279-1.4412c-0.0512-0.4934-0.0768-0.9891-0.0767-1.4852
				c-0.0003-0.4918,0.0251-0.9833,0.0761-1.4724c0.0503-0.4887,0.1266-0.9743,0.2285-1.4549
				c0.1013-0.481,0.2284-0.9562,0.3808-1.4235l-1.1711-0.3808"/>
			<path fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" d="M86.5459,84.2184l-1.1743,0.3818
				c0,0,0.2825,0.9383,0.3841,1.4216c0.1007,0.4761,0.177,0.9571,0.2284,1.4411c0.1023,0.9832,0.1025,1.9744,0.0007,2.9577
				c-0.0506,0.489-0.1271,0.9749-0.2291,1.4558c-0.1016,0.4833-0.3841,1.4216-0.3841,1.4216l1.1743,0.3817"/>
			<g>
				<path fill="#231F20" d="M70.6809,76.3551h0.3652v2.8027h-0.3652V76.3551z"/>
			</g>
			<g>
				<path fill="#231F20" d="M72.3259,78.7711h1.0664v0.3867h-1.7729v-0.0283l0.1685-0.1982
					c0.2632-0.3262,0.4731-0.6035,0.6289-0.8311c0.1558-0.2266,0.2573-0.3984,0.3047-0.5146
					c0.0474-0.1172,0.0713-0.2314,0.0713-0.3457c0-0.1572-0.0449-0.2842-0.1343-0.3799c-0.0898-0.0957-0.209-0.1436-0.3574-0.1436
					c-0.1123,0-0.2227,0.0332-0.332,0.0996c-0.1089,0.0664-0.2065,0.1592-0.2935,0.2793v-0.5088
					c0.2178-0.1787,0.4424-0.2676,0.6738-0.2676c0.2446,0,0.4463,0.082,0.605,0.2451c0.1582,0.1631,0.2373,0.3701,0.2373,0.6221
					c0,0.1123-0.0195,0.2324-0.0591,0.3604c-0.0391,0.127-0.1089,0.2744-0.2095,0.4414c-0.1001,0.166-0.2705,0.3936-0.5112,0.6807
					L72.3259,78.7711z"/>
			</g>
			<g>
				<path fill="#231F20" d="M58.4665,96.1007l0.3203,0.5547l-0.2012,0.1162l-0.5332-0.9229l0.0146-0.0078l0.1543,0.0273
					c0.249,0.0391,0.4561,0.0645,0.6211,0.0771c0.1655,0.0127,0.2852,0.0146,0.3599,0.0049
					c0.0752-0.0117,0.1411-0.0332,0.2007-0.0674c0.082-0.0479,0.1348-0.1084,0.1577-0.1846
					c0.0229-0.0742,0.0122-0.1514-0.0322-0.2285c-0.0337-0.0586-0.0845-0.1055-0.1519-0.1426
					c-0.0669-0.0371-0.1455-0.0605-0.2339-0.0693l0.2656-0.1533c0.1572,0.0605,0.272,0.1504,0.3413,0.2715
					c0.0732,0.127,0.0918,0.2559,0.0537,0.3877c-0.0371,0.1318-0.1211,0.2354-0.252,0.3105
					c-0.0586,0.0342-0.1265,0.0596-0.2051,0.0771c-0.0791,0.0186-0.1758,0.0254-0.293,0.0244
					c-0.1162-0.0029-0.2861-0.0225-0.5078-0.0615L58.4665,96.1007z"/>
				<path fill="#231F20" d="M60.4187,96.5343c0.0771,0.1338,0.0703,0.2852-0.0195,0.4531s-0.2422,0.3145-0.458,0.4395
					c-0.2212,0.127-0.4268,0.1875-0.6157,0.1807c-0.189-0.0078-0.3237-0.0811-0.4038-0.2197
					c-0.0815-0.1426-0.0791-0.2949,0.0068-0.458c0.0869-0.1641,0.2422-0.3115,0.4663-0.4404
					c0.2207-0.127,0.4263-0.1875,0.6167-0.1797C60.2014,96.3175,60.3372,96.3937,60.4187,96.5343z M60.2214,96.6515l-0.0063-0.0107
					c-0.0464-0.0801-0.1323-0.1152-0.2573-0.1055c-0.126,0.0098-0.2734,0.0635-0.4414,0.1611
					c-0.1729,0.0996-0.2949,0.2002-0.3662,0.3027c-0.0713,0.1035-0.0845,0.1943-0.0381,0.2754
					c0.0469,0.0801,0.1328,0.1162,0.2578,0.1055c0.125-0.0098,0.2725-0.0625,0.4404-0.1602
					c0.1699-0.0977,0.291-0.1973,0.3652-0.3008S60.2649,96.7267,60.2214,96.6515z"/>
			</g>

				<linearGradient id="SVGID_15_A-22" gradientUnits="userSpaceOnUse" x1="72.9547" y1="471.0254" x2="71.1123" y2="467.8342" gradientTransform="matrix(1 0 0 1 0 -380.4812)">
				<stop  offset="0" style="stop-color:#FFFFFF"/>
				<stop  offset="0.3022" style="stop-color:#FCFCFC"/>
				<stop  offset="0.5005" style="stop-color:#F4F4F4"/>
				<stop  offset="0.669" style="stop-color:#E5E5E5"/>
				<stop  offset="0.8207" style="stop-color:#CFCFCF"/>
				<stop  offset="0.9599" style="stop-color:#B4B4B4"/>
				<stop  offset="1" style="stop-color:#ABABAB"/>
			</linearGradient>
			<path fill="url(#SVGID_15_A-22)" stroke="#231F20" stroke-width="0.0588" stroke-miterlimit="10" d="M73.8756,88.949
				c-0.0002,1.0174-0.8251,1.8419-1.8425,1.8417c-1.0174-0.0002-1.8419-0.8251-1.8417-1.8425
				c0.0002-1.0167,0.8241-1.841,1.8408-1.8417c1.0175-0.0006,1.8428,0.8237,1.8434,1.8412
				C73.8756,88.9482,73.8756,88.9486,73.8756,88.949z"/>
			<g>
				<path fill="#231F20" d="M71.2263,73.9567h0.0146c0.105,0,0.1855-0.0215,0.2402-0.0645
					c0.0552-0.0439,0.0825-0.1064,0.0825-0.1895c0-0.0752-0.0264-0.1357-0.0801-0.1826c-0.0532-0.0459-0.1235-0.0693-0.2104-0.0693
					c-0.0874,0-0.1846,0.0273-0.2915,0.082v-0.2305c0.0981-0.0488,0.2051-0.0732,0.3208-0.0732c0.1548,0,0.2773,0.04,0.3667,0.1211
					c0.0898,0.0811,0.1348,0.1924,0.1348,0.333c0,0.085-0.0176,0.1562-0.0518,0.2148c-0.0347,0.0586-0.0898,0.1084-0.1655,0.1504
					c0.0659,0.0254,0.1143,0.0566,0.145,0.0938c0.0303,0.0381,0.0542,0.083,0.0708,0.1357
					c0.0171,0.0537,0.0254,0.1094,0.0254,0.1689c0,0.1475-0.0488,0.2695-0.147,0.3652c-0.0981,0.0967-0.2217,0.1445-0.3716,0.1445
					c-0.1274,0-0.251-0.0312-0.3701-0.0928V74.601c0.1274,0.0791,0.2505,0.1191,0.3701,0.1191c0.0815,0,0.1465-0.0244,0.1963-0.0723
					c0.0493-0.0488,0.0742-0.1123,0.0742-0.1924c0-0.0664-0.0205-0.125-0.0615-0.1748c-0.0244-0.0273-0.0513-0.0488-0.0806-0.0615
					c-0.0293-0.0137-0.0923-0.0264-0.1895-0.0381l-0.022-0.0029v-0.2214H71.2263z"/>
				<path fill="#231F20" d="M72.6428,73.2311c0.1543,0,0.2817,0.0811,0.3828,0.2432c0.1006,0.1621,0.1514,0.3672,0.1514,0.6162
					c0,0.2559-0.0508,0.4639-0.1514,0.624c-0.1011,0.1592-0.2319,0.2393-0.3926,0.2393c-0.1631,0-0.2939-0.0781-0.3931-0.2344
					c-0.0986-0.1572-0.1479-0.3652-0.1479-0.624c0-0.2549,0.0508-0.4629,0.1528-0.624
					C72.3469,73.3111,72.4797,73.2311,72.6428,73.2311z M72.6453,73.4606H72.633c-0.0923,0-0.1655,0.0566-0.2197,0.1699
					c-0.0547,0.1143-0.0815,0.2686-0.0815,0.4629c0,0.1992,0.0264,0.3555,0.0796,0.4688s0.126,0.1699,0.2192,0.1699
					s0.167-0.0566,0.2207-0.1699s0.0811-0.2676,0.0811-0.4619c0-0.1953-0.0264-0.3506-0.0781-0.4668
					C72.8025,73.5182,72.7327,73.4606,72.6453,73.4606z"/>
			</g>
			<g>
				<path fill="#231F20" d="M83.654,96.6012l0.1211-0.209l1.459,0.8423l-0.1211,0.209L83.654,96.6012z"/>
				<path fill="#231F20" d="M84.3171,95.4108c0.0771-0.1338,0.2109-0.2036,0.4023-0.21c0.1904-0.0063,0.3936,0.0527,0.6094,0.1772
					c0.2217,0.1279,0.376,0.2754,0.4639,0.4429c0.0879,0.167,0.0918,0.3203,0.0117,0.4595
					c-0.082,0.1416-0.2148,0.2158-0.3994,0.2231c-0.1855,0.0068-0.3906-0.0542-0.6143-0.1836
					c-0.2207-0.1274-0.376-0.2754-0.4648-0.4443C84.238,95.7071,84.2361,95.5519,84.3171,95.4108z M84.5173,95.5236l-0.0059,0.0103
					c-0.0469,0.0801-0.0342,0.1719,0.0371,0.2754c0.0713,0.1045,0.1914,0.2051,0.3604,0.3022
					c0.1719,0.0996,0.3203,0.1548,0.4453,0.165c0.125,0.0107,0.21-0.0239,0.2568-0.1045c0.0469-0.0811,0.0342-0.1733-0.0371-0.2764
					s-0.1904-0.2041-0.3594-0.3013c-0.1689-0.0977-0.3164-0.1528-0.4434-0.1655C84.6462,95.4161,84.5603,95.4479,84.5173,95.5236z"
					/>
			</g>
			<g>
				<path fill="#231F20" d="M72.2092,98.7028l0.04-0.0283l0.2427,0.3057c-0.2139,0.1377-0.3911,0.2881-0.5322,0.4521
					c-0.1411,0.1631-0.25,0.3555-0.3262,0.5762c0.1484-0.0762,0.2964-0.1143,0.4434-0.1143c0.2207,0,0.4067,0.0781,0.5576,0.2354
					c0.1514,0.1562,0.2266,0.3477,0.2266,0.5752c0,0.2344-0.082,0.4326-0.2466,0.5957s-0.3643,0.2451-0.5996,0.2451
					c-0.2637,0-0.4766-0.0928-0.6392-0.2783c-0.1626-0.1846-0.2437-0.4268-0.2437-0.7266c0-0.2246,0.042-0.4482,0.1255-0.6709
					s0.2036-0.4316,0.3608-0.626C71.7756,99.0485,71.9724,98.8688,72.2092,98.7028z M71.5471,100.4244
					c-0.0107,0.0625-0.0156,0.1328-0.0156,0.21c0,0.1582,0.0454,0.2881,0.1372,0.3896s0.209,0.1523,0.3521,0.1523
					c0.1284,0,0.2344-0.0439,0.3179-0.1309s0.1255-0.1963,0.1255-0.3281c0-0.1357-0.0444-0.2451-0.1333-0.3281
					c-0.0894-0.084-0.2065-0.126-0.3521-0.126c-0.0752,0-0.1431,0.0117-0.2036,0.0342
					C71.7141,100.3199,71.6384,100.3629,71.5471,100.4244z"/>
			</g>
			<g>
				<path fill="#231F20" d="M60.2483,90.2369l-0.2471-0.291c0.2075-0.1309,0.3887-0.29,0.5439-0.4766
					c0.1548-0.1865,0.2588-0.3779,0.3105-0.5742c-0.127,0.0781-0.2759,0.1182-0.4473,0.1182c-0.2139,0-0.3975-0.0801-0.5508-0.2393
					c-0.1528-0.1592-0.2295-0.3496-0.2295-0.5732c0-0.2324,0.0815-0.4297,0.2446-0.5918s0.3623-0.2432,0.5981-0.2432
					c0.2646,0,0.4814,0.0957,0.6499,0.2871s0.2524,0.4365,0.2524,0.7363c0,0.3398-0.1055,0.6826-0.3169,1.0303
					C60.845,89.7662,60.5759,90.0387,60.2483,90.2369z M60.9343,88.4957c0.0156-0.1074,0.0239-0.1768,0.0239-0.209
					c0-0.1611-0.0454-0.2939-0.1353-0.3975c-0.0903-0.1025-0.2065-0.1543-0.3481-0.1543c-0.1299,0-0.2373,0.0439-0.3223,0.1318
					s-0.1274,0.1973-0.1274,0.3301c0,0.1211,0.0464,0.2266,0.1387,0.3145c0.0923,0.0889,0.2026,0.1328,0.3311,0.1328
					C60.6448,88.6442,60.7908,88.5944,60.9343,88.4957z"/>
			</g>
			<g>
				<path fill="#231F20" d="M83.155,88.5738h0.0244c0.1748,0,0.3086-0.0361,0.4004-0.1084
					c0.0908-0.0723,0.1367-0.1768,0.1367-0.3145c0-0.125-0.0439-0.2256-0.1328-0.3037c-0.0889-0.0771-0.2061-0.1162-0.3506-0.1162
					c-0.1455,0-0.3076,0.0459-0.4854,0.1367V87.485c0.1631-0.082,0.3408-0.123,0.5342-0.123c0.2578,0,0.4609,0.0674,0.6104,0.2031
					c0.1494,0.1348,0.2236,0.3193,0.2236,0.5527c0,0.1416-0.0283,0.2607-0.0859,0.3584c-0.0576,0.0967-0.1494,0.1797-0.2754,0.249
					c0.1104,0.043,0.1904,0.0957,0.2412,0.1572c0.0508,0.0625,0.0898,0.1377,0.1182,0.2266c0.0283,0.0879,0.042,0.1816,0.042,0.2803
					c0,0.2451-0.0811,0.4473-0.2441,0.6074s-0.3691,0.2402-0.6182,0.2402c-0.2129,0-0.418-0.0518-0.6162-0.1543v-0.4375
					c0.2119,0.1318,0.417,0.1982,0.6162,0.1982c0.1348,0,0.2441-0.04,0.3262-0.1201s0.123-0.1865,0.123-0.3193
					c0-0.1104-0.0342-0.208-0.1025-0.29c-0.04-0.0469-0.084-0.082-0.1328-0.1035c-0.0488-0.0225-0.1543-0.043-0.3164-0.0635
					L83.155,88.943V88.5738z"/>
			</g>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="84.1628" y1="81.9121" x2="85.2323" y2="81.2951"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="58.7162" y1="81.2951" x2="59.7857" y2="81.9121"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="71.9749" y1="104.258" x2="71.9749" y2="103.0228"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="68.6513" y1="101.3513" x2="68.9715" y2="100.1591"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="74.9783" y1="77.74" x2="75.2985" y2="76.5469"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="65.5548" y1="100.0692" x2="66.1719" y2="98.9991"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="77.7766" y1="78.899" x2="78.3943" y2="77.8299"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="62.8951" y1="98.0286" x2="63.768" y2="97.1557"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="80.1805" y1="80.7434" x2="81.0534" y2="79.8705"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="60.8558" y1="95.3689" x2="61.9239" y2="94.7518"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="82.0245" y1="83.1463" x2="83.094" y2="82.5302"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="59.5715" y1="92.2728" x2="60.7647" y2="91.9535"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="83.1838" y1="85.9456" x2="84.3757" y2="85.6273"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="59.5715" y1="85.6263" x2="60.7647" y2="85.9456"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="83.1838" y1="91.9535" x2="84.3757" y2="92.2728"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="60.8558" y1="82.5302" x2="61.9239" y2="83.1463"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="82.0245" y1="94.7518" x2="83.0927" y2="95.3689"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="62.8951" y1="79.8705" x2="63.768" y2="80.7434"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="80.1805" y1="97.1557" x2="81.0534" y2="98.0286"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="65.5548" y1="77.8299" x2="66.1719" y2="78.899"/>

				<line fill="none" stroke="#231F20" stroke-width="0.4938" stroke-miterlimit="10" x1="77.7766" y1="98.9991" x2="78.3943" y2="100.0692"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="68.6513" y1="76.5469" x2="68.9702" y2="77.74"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1235" stroke-miterlimit="10" x1="74.977" y1="100.1591" x2="75.2972" y2="101.3513"/>
		</g>
	</g>
</g>
<g id="Hands_A-22">
	<g id="Small_Second_A-22">
		<path fill="#231F20" d="M71.9987,129.2752c1.096-0.0014,1.9855,0.8858,1.987,1.9818s-0.8858,1.9855-1.9818,1.987
			c-1.096,0.0014-1.9855-0.8858-1.987-1.9818c0-0.0002,0-0.0002,0-0.0003C70.0158,130.1661,70.903,129.2768,71.9987,129.2752z
			 M71.0845,131.2607c0.0008,0.5061,0.4116,0.9159,0.9178,0.9152c0.5062-0.0007,0.9159-0.4116,0.9152-0.9178
			c-0.0007-0.506-0.4112-0.9155-0.9171-0.9152c-0.5057,0.0001-0.9156,0.4102-0.9155,0.9159c0,0.0007,0,0.0015,0,0.0022
			L71.0845,131.2607z"/>
		<polygon fill="#FFFFFF" points="73.5398,127.0055 72.7877,129.2567 71.2111,129.2584 70.4523,127.0084 71.9905,122.2556 		"/>
		<path fill="#231F20" d="M72.583,128.9735l-1.1689,0.0015l-0.6633-1.9684l1.2404-3.8336l1.2499,3.8306l-0.6583,1.9697
			 M72.9914,129.5397l0.847-2.534l-1.8493-5.6671l-1.8353,5.6714l0.8531,2.5323L72.9914,129.5397L72.9914,129.5397z"/>
		<polygon fill="#231F20" points="72.9914,129.5402 72.9906,128.7172 71.0064,128.7195 71.0072,129.5425 		"/>
	</g>
  <g id="Chrono_Hour_A-22">
    <path fill="#231F20" d="M72.486,87.0414c1.067,0.2501,1.7292,1.3178,1.4791,2.3848c-0.25,1.067-1.3178,1.7292-2.3848,1.4791
      s-1.7292-1.3178-1.4791-2.3848c0,0,0-0.0001,0.0001-0.0001C70.3516,87.4535,71.4192,86.7914,72.486,87.0414z M71.1405,88.7641
      c-0.1155,0.4929,0.1904,0.986,0.6834,1.1016c0.4929,0.1154,0.986-0.1904,1.1016-0.6834
      c0.1155-0.4927-0.1903-0.9858-0.6829-1.1015c-0.4928-0.1158-0.9861,0.1899-1.1017,0.6827
      C71.1406,88.7636,71.1405,88.7639,71.1405,88.7641z"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="72.0162" y1="86.9886" x2="71.9998" y2="79.0366"/>
  </g>
  <g id="Chrono_Minute_A-22">
    <path fill="#231F20" d="M73.1717,87.9171c0.5565,0.6573,0.4749,1.6411-0.1824,2.1977c-0.6573,0.5565-1.6412,0.4747-2.1977-0.1824
      c-0.5565-0.6573-0.4748-1.6412,0.1824-2.1977c0.0001-0.0001,0.0003-0.0002,0.0005-0.0004
      C71.6318,87.1782,72.6153,87.2601,73.1717,87.9171z M71.5541,88.4192c-0.2789,0.236-0.3137,0.6533-0.0778,0.9323
      c0.236,0.2789,0.6534,0.3137,0.9323,0.0778c0.2789-0.236,0.3137-0.6534,0.0778-0.9323c-0.2358-0.2789-0.6531-0.3138-0.9319-0.078
      C71.5544,88.419,71.5543,88.4192,71.5541,88.4192z"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="71.9681" y1="87.3654" x2="72" y2="76.1712"/>
  </g>
	<g id="Hour_A-22">
    <path fill="#231F20" d="M69.2481,111.9356c-1.0907-1.5191-0.7433-3.6348,0.7759-4.7255
      c1.5191-1.0907,3.6348-0.7433,4.7255,0.7759s0.7433,3.6348-0.7759,4.7255c-0.5773,0.4145-1.2705,0.6368-1.9812,0.6355
      C70.9031,113.3484,69.8805,112.8225,69.2481,111.9356z M73.5089,108.8768c-0.5985-0.8342-1.7599-1.0254-2.5941-0.4269
      c-0.8342,0.5985-1.0254,1.7599-0.4269,2.5941c0.5985,0.8342,1.7599,1.0254,2.5941,0.4269
      c0.4858-0.3485,0.7744-0.9094,0.7754-1.5072C73.8595,109.5737,73.7375,109.193,73.5089,108.8768z"/>
    <path fill="#595A5C" d="M74.7623,107.977l-0.0255,0.0183c1.0855,1.5119,0.7397,3.6175-0.7722,4.7029
      c-0.5746,0.4125-1.2645,0.6338-1.9718,0.6324c-1.083-0.0035-2.0989-0.5257-2.7318-1.4045
      c-1.0854-1.512-0.7396-3.6175,0.7723-4.7029c0.5746-0.4125,1.2643-0.6338,1.9715-0.6324
      c1.083,0.0036,2.0988,0.5259,2.732,1.4046l0.0255-0.0183 M70.476,111.0538c0.6035,0.8409,1.7746,1.0334,2.6156,0.4298
      c0.4896-0.3514,0.7804-0.9168,0.7814-1.5195c0.0017-0.3935-0.1213-0.7774-0.3515-1.0964
      c-0.6037-0.841-1.7748-1.0334-2.6157-0.4297c-0.4896,0.3514-0.7803,0.9169-0.7814,1.5196
      C70.1229,110.3509,70.246,110.7347,70.476,111.0538 M74.7623,107.9771c-1.0953-1.5265-3.2206-1.8759-4.7471-0.7806
      s-1.8759,3.2206-0.7806,4.7471s3.2206,1.8759,4.7471,0.7806c0.8886-0.6377,1.4164-1.6637,1.4185-2.7574
      C75.402,109.253,75.1788,108.5568,74.7623,107.9771z M70.5016,111.0354c-0.5934-0.8269-0.4042-1.9782,0.4227-2.5716
      s1.9782-0.4042,2.5716,0.4227c0.5934,0.8269,0.4042,1.9782-0.4227,2.5716c-0.3141,0.2254-0.691,0.3463-1.0776,0.3457
      C71.4027,111.8039,70.8464,111.5178,70.5016,111.0354z"/>
    <polygon fill="#FFFFFF" points="69.1896,99.7488 72.0445,84.0199 74.844,99.7588 73.497,106.6799 70.5137,106.6744 				"/>
    <path fill="#231F20" d="M72.0399,86.4232l2.3713,13.3318l-1.2655,6.4986l-2.2812-0.0037l-1.2421-6.5031l2.4178-13.3233
       M72.0486,81.6147L68.757,99.751l1.404,7.3486l3.685,0.0062l1.4302-7.3438l-3.228-18.1475L72.0486,81.6147z"/>
    <rect x="69.7404" y="103.2997" transform="matrix(0.0018 -1 1 0.0018 -33.2589 176.9672)" fill="#231F20" width="4.5378" height="3.685"/>
	</g>
	<g id="Minute_A-22">
    <path fill="#231F20" d="M74.6466,110.9512c-0.5382,1.4618-2.1595,2.2106-3.6213,1.6724
      c-1.4618-0.5382-2.2106-2.1595-1.6724-3.6213s2.1595-2.2106,3.6213-1.6724c1.1101,0.4087,1.8472,1.4667,1.8461,2.6495
      C74.8197,110.3111,74.7609,110.64,74.6466,110.9512z M70.6565,109.4794c-0.2738,0.7426,0.1063,1.5666,0.849,1.8403
      c0.7426,0.2738,1.5665-0.1064,1.8403-0.849l0,0c0.276-0.7418-0.1015-1.567-0.8432-1.843
      c-0.7418-0.276-1.5668,0.1015-1.843,0.8432C70.6585,109.4738,70.6575,109.4766,70.6565,109.4794z"/>
    <path fill="#595A5C" d="M69.3411,108.9939l0.0295,0.0109c0.5353-1.4532,2.1474-2.1973,3.6007-1.662
      c1.4532,0.5353,2.1973,2.1474,1.662,3.6007c-0.5353,1.4532-2.1474,2.1973-3.6007,1.662
      c-1.1032-0.4064-1.8358-1.4578-1.8348-2.6335c0.0005-0.3301,0.059-0.6575,0.1729-0.9672L69.3411,108.9939 M73.3606,110.4774
      c0.2774-0.7508-0.1063-1.5843-0.8571-1.8616c-0.7508-0.2774-1.5842,0.1063-1.8616,0.8571s0.1063,1.5843,0.8571,1.8616
      c0.1601,0.0592,0.3295,0.0896,0.5002,0.0898C72.6071,111.4267,73.1514,111.0481,73.3606,110.4774 M69.3411,108.994
      c-0.5422,1.4688,0.209,3.0991,1.6778,3.6413c1.4688,0.5422,3.0991-0.209,3.6414-1.6779s-0.209-3.0991-1.6778-3.6413
      c-0.3131-0.1155-0.6441-0.1749-0.9778-0.1754C70.8154,107.137,69.7508,107.8776,69.3411,108.994z M73.331,110.4664
      c-0.2707,0.7351-1.086,1.1114-1.8211,0.8408c-0.735-0.2707-1.1114-1.086-0.8408-1.8211c0.2707-0.735,1.086-1.1114,1.8211-0.8408
      c0.5582,0.2055,0.9287,0.7375,0.9282,1.3323C73.4182,110.1444,73.3886,110.3099,73.331,110.4664z"/>
    <polygon fill="#FFFFFF" points="70.9539,107.0947 69.1896,95.225 72.0511,71.1041 74.85,95.2318 73.0562,107.0974 				"/>
    <path fill="#231F20" d="M72.0466,74.7528l2.3755,20.4714l-1.7316,11.4467l-1.3699-0.0016l-1.7023-11.4511l2.4285-20.4657
       M72.0562,67.4558l-3.2963,27.7753l1.8267,12.2881l2.8345,0.0032l1.8581-12.283L72.0556,67.456L72.0562,67.4558z"/>
    <polygon fill="#231F20" points="74.1505,98.9231 73.4264,103.4518 73.4211,107.9827 70.5861,107.978 70.592,103.4484
      69.9013,98.9174 			"/>
	</g>
	<g id="Second_A-22">
    <path fill="#231F20" d="M70.605,108.71c0.6826-0.7595,1.8516-0.8219,2.6112-0.1393c0.7595,0.6826,0.8219,1.8516,0.1393,2.6112
      c-0.6826,0.7595-1.8516,0.8219-2.6112,0.1393c-0.3902-0.3506-0.613-0.8506-0.6131-1.3752
      C70.1307,109.4895,70.2996,109.0491,70.605,108.71z"/>
    <path fill="#595A5C" d="M73.3215,111.1578L73.3215,111.1578c-0.6694,0.7419-1.8137,0.8006-2.5555,0.1311
      c-0.7419-0.6694-0.8006-1.8137-0.1311-2.5555c0.6694-0.7419,1.8136-0.8006,2.5555-0.1311
      c0.3806,0.3435,0.5977,0.8324,0.5972,1.3451C73.7867,110.3945,73.6207,110.8255,73.3215,111.1578 M73.3753,111.2062
      c0.6948-0.7726,0.6317-1.962-0.1409-2.6568c-0.7726-0.6948-1.962-0.6317-2.6569,0.1408
      c-0.6948,0.7726-0.6316,1.9621,0.1409,2.6568c0.3452,0.3105,0.793,0.4823,1.2573,0.4824
      C72.5097,111.83,73.0185,111.6034,73.3753,111.2062L73.3753,111.2062z"/>
    <polygon fill="#231F20" points="71.6925,111.8292 72.2596,111.8288 72.8199,124.1193 71.1191,124.1183 				"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="71.9758" y1="111.8295" x2="72" y2="67.4269"/>
	</g>
</g>
</svg>
</template>

<script>
export default {
  name: 'a22',
};
</script>
